(function() {
  'use strict';

  angular
    .module('vinelib', [
        'ui.router',
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        // 'ngSanitize',
        'ngMessages',
        'ngAria',
        'restangular',
        'ui.bootstrap',
        'rex-string-helper', //Str
        'angular-jwt',
        'ngAside', //Side Menu
        'formly',
        'formlyBootstrap',
        'textAngular',
        'as.sortable',
        'angularSpinner',
        'ngAudio'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('SearchController', SearchController);

  /** @ngInject */
  function SearchController($stateParams, resourceService) {
    var vm = this;
    
    vm.searchTerm = resourceService.data.searchTerm;
    vm.results = resourceService.data.searchResults;
    vm.searching = resourceService.data.searching;

    resourceService.search( $stateParams.searchTerm );
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('ResourceController', ResourceController);

  /** @ngInject */
  function ResourceController(resourceModel, $sce, $state, ngAudio) {
    var vm = this;
    vm.resource = [];
    vm.currentYear = new Date().getFullYear();
    vm.mediaSources = {
      mediaPlayer: null,
      downloads: []
    };
    vm.audio = null; //holds audio player object

    loadResource();
    loadMedia();

    function loadResource() {
      //Get data via model - now preloaded in state
      // assign resource properties directly to vm since it has the same name
      if( resourceModel ) {
        angular.extend( vm, resourceModel ); //didn't do it with Object.assign(vm, data); as no IE support. watch out for arrays
        vm.author = vm.author.data;
        vm.comments = vm.comments.data;
        vm.categories = vm.categories.data;
        vm.media = vm.media.data;
      } else {
        $state.go('home');
      }
    }

    function loadMedia() {
      var mediaTypes = {
        'default': {
          icon: 'fa-file-text-o'
        },
        'vimeo': {
          'player': 'vimeo',
          'icon': 'fa-file-video-o'
        },
        'youtube': {
          'player': 'vimeo',
          'icon': 'fa-file-video-o'
        },
        'audio/mp3': {
          'player': 'audio',
          'icon': 'fa-file-audio-o'
        },
        // '': {
        //   icon: 'fa-file-archive-o'
        // },
        'application/excel': {
          icon: 'fa-file-excel-o'
        },
        'image/jpeg': {
          icon: 'fa-file-image-o'
        },
        'image/png': {
          icon: 'fa-file-image-o'
        },
        'application/pdf': {
          icon: 'fa-file-pdf-o'
        },
        // '': {
        //   icon: 'fa-file-powerpoint-o'
        // },
        'application/word': {
          icon: 'fa-file-word-o'
        }
      };

      var mediaFile = null;
      for (var i = 0; i < vm.media.length; i++) {
        mediaFile = vm.media[i];
        
        //if the filetype is listed above, deal with it, otherwise make it a download
        var type = mediaTypes.hasOwnProperty( mediaFile.file_type ) ? mediaTypes[ mediaFile.file_type ] : mediaTypes['default'];

        if( type.player ) { //any media files to be loaded in a player
          if( vm.mediaSources.mediaPlayer === null ) { //if there's no media player file, add it
            vm.mediaSources.mediaPlayer = {
              enabled: true,
              player: type.player,
              title: mediaFile.title,
              url: $sce.trustAsResourceUrl( mediaFile.url )
            }
            if( type.player === 'audio' ) {
              vm.audio = ngAudio.load( mediaFile.url );
            }
          } else { //otherwise add it to downloads
            mediaFile.icon = type.icon;
            vm.mediaSources.downloads.push( mediaFile );   
          }
        } else { //add it to the download
          mediaFile.icon = type.icon;
          vm.mediaSources.downloads.push( mediaFile ); 
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($stateParams) {
    var vm = this;
    vm.formtype = $stateParams.formtype;
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('PasswordController', PasswordController);

  /** @ngInject */
  function PasswordController($timeout, $state, $stateParams, userService, usSpinnerService ) {
    var vm = this;
    vm.model = {};

    loadData();

    function loadData() {
      // load the data from $stateParams if appropriate
      if( $state.current.name === 'password-change' ) {
        vm.model.email = $stateParams.email;
        vm.model.token = $stateParams.token;

        if( ! vm.model.token ) {
          showMessage('This form only works when it is opened from Password Reset email. If you have forgotton your password, please go to the login page and click Forgot Password.', 'error');
        }
      }
    }


    vm.passwordResetFields = [
      {
        key: 'email',
        type: 'input',
        templateOptions: {
          type: 'email',
          label: 'Email address',
          placeholder: 'Enter email',
          required: true,
          text: 'Please enter the email address you registered with and we\'ll send you an email with a link to reset your password'
        }
      }
    ];

    vm.onResetSubmit = function() {
      usSpinnerService.spin('submit-spinner');
      userService.sendPasswordEmail(vm.model)
        .then( function() {
          showMessage("We've sent you an email with a link to reset your password",'success');
        }, function() {
          showMessage("There was an error resetting your password. This usually occurs when your email address is not in our system",'error');
        }
      );
    }

    vm.passwordChangeFields = [
      {
        key: 'email',
        type: 'input',
        templateOptions: {
          type: 'hidden',
          required: true
        }
      },
      {
        key: 'token',
        type: 'input',
        templateOptions: {
          type: 'hidden',
          required: true
        }
      },
      {
        key: 'password',
        type: 'input',
        templateOptions: {
          type: 'password',
          label: 'New Password',
          placeholder: 'Please enter a new password that is 8 or more characters',
          required: true
        },
        validators:{
          minLength: '$viewValue.length >=8'
        }
      },
      {
        key: 'password_confirmation',
        type: 'input',
        templateOptions: {
          type: 'password',
          label: 'Confirm Password',
          required: true
        }
      }      
    ];
    
    vm.onChangeSubmit = function() {
      usSpinnerService.spin('submit-spinner');
      if( vm.model.password !== vm.model.password_confirmation ) {
        showMessage("Please ensure your passwords match", 'error');
        return false;
      }

      userService.resetPassword(vm.model)
        .then( function() {
          showMessage("Password Successfully Reset",'success');
          loginUser(vm.model);
        }, function() {
          showMessage("There was an error resetting your password.",'error');
        }
      );
    }

     function loginUser(data) {
      userService.login( data )
        .then(function() {
          $state.go('home');
        }, function() {
          showMessage("There was an error logging in. Please report this error to info@thevineproject.com", 'error');
        }
      );
    }

    function showMessage(message, style) {
      vm.messageClass = style==='error' ? 'alert-danger' : 'alert-success';
      vm.messageMessage = message;
      usSpinnerService.stop('submit-spinner');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('MembershipController', MembershipController);

  /** @ngInject */
  function MembershipController($stateParams) {
    var vm = this;
    vm.page = $stateParams.page;
    vm.formtype = $stateParams.formtype;
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('MediaController', MediaController);

  /** @ngInject */
  function MediaController($stateParams, $scope, Media, Restangular) {
    var vm = this;
    vm.message = $stateParams.message;

    vm.medias = [];
    vm.mediaToEdit = null;
    vm.formFields = [];
    vm.pagination;

    loadAllMedia();
    loadFormFields();

    //Listen for file Uploads
    var unlisten = $scope.$on('fileToUpload', function(event, arg) {
      vm.fileToUpload = arg;
    });

    // remove the listener
    $scope.$on('$destroy', unlisten);

    vm.onEditSubmit = function() {
      Media.uploadFile( vm.mediaToEdit, vm.fileToUpload )
        .then( function(data) {
          if( vm.indexToEdit === null ) {
            vm.medias.push(data);
          } else {
            vm.medias[ vm.indexToEdit ] = data;
          }
          vm.mediaToEdit = null;
        });
    }

    vm.editMedia = function(media) {
      vm.mediaToEdit = media;
      vm.indexToEdit = vm.medias.indexOf(media);
    };

    vm.addNewImage = function() {
      vm.mediaToEdit = {
        'media_type': 'general',
        'resource_id': 0
      };
      vm.indexToEdit = null;
    };

    vm.removeImage = function() {
      Restangular.restangularizeElement(null, vm.mediaToEdit, 'media');
      vm.mediaToEdit.remove()
        .then( function() {
          vm.mediaToEdit = null;
          vm.medias.splice( vm.indexToEdit, 1);
        });
    }

    vm.pageChanged = function() {
      loadAllMedia();
    };

    function loadAllMedia() {
      var params = {
        page: vm.pagination,
        type: 'general'
      }

      return Media.getList(params).then(function(data){
        vm.medias = data;
      }); 
    }

    function loadFormFields() {
      vm.formFields = [
        {
          key: 'title',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Title',
            placeholder: 'Enter the Title of this Media',
            required: true
          }
        },
        {
          key: 'file',
          type: 'upload',
          templateOptions: {
            label: 'Media File',
            required: true
          }
        }
      ];
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($stateParams, categoryService, userService, configService, $state, optionService, $sce) {
    var vm = this;

    vm.openSignup = function() {
       $state.go('join.info');
    }

    function init() {
      vm.user = userService.currentUser;
      vm.categorySlug = $stateParams.categorySlug ? $stateParams.categorySlug : 'phaseresources';
      vm.interface = configService.getLocalConfig( 'interface' );
      vm.resources = categoryService.featuredResources;
      vm.options = optionService.globalOptions;
    }

    vm.getWelcomeText = function() {
      var html;
      if( vm.user.loggedIn ) {
        html = vm.options.homeWelcomeAuth + vm.options.homeWelcomeAlways;
      } else {
        html = vm.options.homeWelcomeUnauth + vm.options.homeWelcomeAlways;
      }

      if( html )
        html = $sce.trustAsHtml( html );

      return html || null;
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('EditresourceController', EditresourceController);

  /** @ngInject */
  function EditresourceController($stateParams, $scope, Media, Restangular, $state, resource, Resource, Str, categoryService, $log) {
    var vm = this;
    vm.message = $stateParams.message;

    //Types of articles
    vm.availableTypes = [];

    //The resource to Edit
    vm.resource = {};

    //Is this an existing resource (or a new one)
    vm.isExisting = false;

    vm.resourceCategoryIds = [];
    vm.formFields = [];
    vm.imageToEdit = null;
    vm.mediaToEdit = null;
    init();

    vm.onEditSubmit = function() {
      var promise;
      clearMessage();
      promise = updateResource();

      promise.then( function() {
        showMessage('Saved Resource','success');
        vm.editresourceForm.$setPristine();
        $state.go( 'admin.editresource', { resourceSlug: vm.resource.slug }, {location: 'replace'});
      }, function(response) {
        $log.error(response);
        showMessage(response.data.message,'error');
        vm.editresourceForm.$setPristine();
      });
    }

    vm.deleteResource = deleteResource;

    /**
     * Choose which categories are added to this resource
     * @param  {obj} category
     * @return {null}
     */
    vm.toggleCategory = function(category) {
      if( category.selected ) {
        category.selected = false;
        removeCategoryFromResource(category);
      } else {
        addCategoryToResource(category);
        category.selected = true;
      }
    };

    //Feature Image Editing functions
    vm.chooseUpdateImage = function() {
      vm.imageToEdit = vm.resource.feature;
    };

    vm.chooseNewImage = function() {
      vm.imageToEdit = vm.resource.feature;
      vm.imageToEdit.media_type = 'feature';
      vm.imageToEdit.resource_id = vm.resource.id;
    };

    vm.removeImage = function() {
      Restangular.restangularizeElement(null, vm.resource.feature, 'media');
      vm.resource.feature.remove()
        .then( function() {
          nullifyObject(vm.resource.feature);
        });
    }

    vm.onImageSubmit = function() {
      Media.uploadFile( vm.imageToEdit, vm.imageFileToUpload )
        .then( function(data) {
          vm.resource.feature = data;
          vm.imageToEdit = null;
        });
    }

    //Media Content Editing Functions
    // choose Media to edit
    vm.chooseUpdateMedia = function( media ) {
      vm.mediaToEdit = media;
      vm.mediaToEdit.remote = ( vm.mediaToEdit.path === 'remote' );
      vm.mediaToEdit.submit_text = 'Update';
    };

    vm.chooseNewMedia = function() {
      vm.mediaToEdit = {
        "submit_text": 'Save',
        "new_media": true,
        "new_upload": true,
        "media_type": 'content',
        "resource_id": vm.resource.id
      }
    };

    vm.closeEditMedia = function() {
      vm.mediaToEdit = null;
    }

    vm.removeMedia = function(media) {
      var index = vm.resource.media.indexOf( media );

      Restangular.restangularizeElement(null, media, 'media');
      media.remove()
        .then( function() {
          vm.resource.media.splice( index, 1 );
          nullifyObject(media);
        });
    }

    vm.onMediaSubmit = function() {
      vm.mediaToEdit.path = ( vm.mediaToEdit.remote ) ? 'remote' : 'content';

      Media.uploadFile( vm.mediaToEdit, vm.mediaFileToUpload )
        .then( function(data) {
          if( ! vm.mediaToEdit.id ) { //If new
            vm.resource.media.push( data );
          } else {
            var index = vm.resource.media.indexOf( vm.mediaToEdit );
            vm.resource.media[ index ] = data;
          }
          vm.mediaToEdit = null;
        });
    }


    function init() {
      loadData();
      loadFormFields();

      var types = categoryService.availableTypes;
      angular.copy( Object.keys(types).map(function (key) { return types[key]; }), vm.availableTypes );
      // for (var i = 0; i < types.length; i++) {
      //   vm.availableTypes.push( types[i] );
      // }

      //Listen for file Uploads
      var unlistenImage = $scope.$on('imageFileToUpload', function(event, arg) {
        vm.imageFileToUpload = arg;
      });
      var unlistenMedia = $scope.$on('mediaFileToUpload', function(event, arg) {
        vm.mediaFileToUpload = arg;
      });

      // remove the listener
      $scope.$on('$destroy', unlistenImage);
      $scope.$on('$destroy', unlistenMedia);

    }

    function nullifyObject(obj) {
      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          obj[property] = null;
        }
      }
    }
    /**
     * Loops through available categories and marks if it is selected or not
     */
    function markAvailableCategoriesAsSelected() {
      var resourceCategoryIds = [];
      var cats = vm.resource.availableCategories;

      for (var j = vm.resource.categories.data.length - 1; j >= 0; j--) {
        resourceCategoryIds.push( vm.resource.categories.data[j].id );
      }

      for (var i = cats.length - 1; i >= 0; i--) {
        for (var n = cats[i].children.length - 1; n >= 0; n--) {
          cats[i].children[n].selected = ( resourceCategoryIds.indexOf( cats[i].children[n].id ) !== -1 );
        }
      }
    }

    function removeCategoryFromResource(category) {
      var cats = vm.resource.categories.data;
      for (var i = cats.length - 1; i >= 0; i--) {
        if( category.id === cats[i].id ) {
          cats.splice(i, 1);
          return true;
        }
      }
    }

    function addCategoryToResource(category) {
      var cats = vm.resource.categories.data;
      for (var i = cats.length - 1; i >= 0; i--) {
        if( category.id === cats[i].id )
          return true;
      }

      cats.push({
        id:   category.id,
        slug: category.cat_slug,
        name: category.cat_name,
        show: category.show,
        desc: category.cat_description
      });
    }

    function updateResource() {
      if( vm.isExisting ) {
        vm.resource.use_method = 'PUT';
      } else {
        vm.resource = Resource.makeModel( vm.resource );
      }
      return vm.resource.post();
    }

    function deleteResource() {
      if( ! vm.isExisting )
        return false;

      vm.resource.remove()
        .then( function() {
          $state.go('admin.resources');
        });
    }

    function showMessage(message, style) {
      vm.resourceClass = style==='error' ? 'alert-danger' : 'alert-success';
      vm.resourceMessage = message;
    }
    
    function clearMessage() {
      vm.resourceMessage = '';
    }

    function loadData() {
      if(resource) { //pre-loaded in state
        if( resource.id )
          vm.isExisting = true;

        vm.resource = resource;
        markAvailableCategoriesAsSelected();
        //promote the data attribute one level
        var promoteData = [ 'feature', 'media', 'availableAuthors' ];
        for (var i = promoteData.length - 1; i >= 0; i--) {
          if( vm.resource[ promoteData[i] ].hasOwnProperty( 'data' ) ) {
            vm.resource[ promoteData[i] ] = vm.resource[ promoteData[i] ].data;
          }
        }
      }
    }

    function loadFormFields() {
      vm.formFields = [
        {
          key: 'title',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Title',
            placeholder: 'Enter the Title of this Resource',
            required: true
          },
          watcher: {
            listener: function() {
              if( !vm.resource.id ) {
                var title = vm.resource.title;
                if( title ) {
                  vm.resource.slug = Str.toSlug(title);
                }
              }
            }
          }
        },
        {
          key: 'slug',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Slug',
            placeholder: 'Enter url-friendly name for this resource',
            required: true
          }
        },
        {
          key: 'description',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Description',
            required: true
          }
        },
        {
          key: 'hide_feature',
          type: 'checkbox',
          templateOptions: {
            label: 'Hide Feature Image from page (still shows as thumbnail)'
          }
        },
        {
          key: "author_id",
          type: "select",
          templateOptions: {
            label: "Author",
            valueProp: "user_id",
            labelProp: "firstname",
            options: vm.resource.availableAuthors
          }
        },
        {
          key: "type",
          type: "select",
          templateOptions: {
            label: "Resource Type",
            valueProp: "type",
            labelProp: "name",
            options: vm.availableTypes
          }
        },
        {
          key: "status",
          type: "select",
          templateOptions: {
            label: "Status",
            valueProp: "status",
            labelProp: "status",
            options: [
              { status: 'draft' },
              { status: 'publish' }
            ]
          }
        },
        {
          key: 'content',
          type: 'editor',
          templateOptions: {
            label: 'Content',
            required: true
          }
        }
      ];
    }

    vm.imageFormFields = [
      {
        key: 'title',
        type: 'input',
        templateOptions: {
          type: 'text',
          label: 'Title',
          placeholder: 'Enter a Title for this Image',
          required: true
        }
      },
      {
        key: 'file',
        type: 'upload',
        templateOptions: {
          label: 'Featured Image File',
          required: true,
          event: 'imageFileToUpload'
        }
      }
    ];

    vm.mediaFormFields = [
      {
        key: 'title',
        type: 'input',
        templateOptions: {
          type: 'text',
          label: 'Title',
          placeholder: 'Enter a Title for this Media',
          required: true
        }
      },
      {
        key: 'remote',
        type: 'checkbox',
        templateOptions: {
          label: 'This media is hosted remotely (e.g on Vimeo or another website)'
        }
      },
      {
        key: 'url',
        type: 'input',
        templateOptions: {
          label: 'Media Location',
          required: true
        },
        hideExpression: "!model.remote"
      },
      {
        key: 'new_upload',
        type: 'checkbox',
        templateOptions: {
          label: 'Upload a new version'
        },
        hideExpression: "model.remote || model.new_media"
      },
      {
        key: 'filename',
        type: 'readonly',
        templateOptions: {
          label: 'File'
        },
        hideExpression: "model.remote || model.new_upload || model.new_media"
      },
      {
        key: 'file',
        type: 'upload',
        templateOptions: {
          label: 'Media File',
          required: true,
          event: 'mediaFileToUpload'
        },
        hideExpression: "model.remote || !model.new_upload"
      }
    ];

  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('EditcategoryController', EditcategoryController);

  /** @ngInject */
  function EditcategoryController($stateParams, Category, $uibModal, Str) {
    var vm = this;
    vm.message = $stateParams.message;
    vm.orderChanged = false;
    vm.categoryToEdit = null;
    vm.resourcesOfSelectedCategory;
    vm.orderResourcesChanged = false;
    vm.indexToEdit;

    vm.categories;
    init();

    vm.dragControlListeners = {
        // accept: function (sourceItemHandleScope, destSortableScope) {return boolean}//override to determine drag is allowed or not. default is true.
        itemMoved: function() {
          vm.orderChanged = true;
        },
        orderChanged: function(event) {
          event.source.itemScope.child.highlight = false;
          vm.orderChanged = true;
        },
        allowDuplicates: false
    };

    vm.saveCategoryOrder = function() {
      if( ! vm.orderChanged )
        return false;

      Category.updateOrder( mapCategoryIds() )
        .then( function() {
          vm.orderChanged = false;
        });
    };

    vm.dragResourceListeners = {
        itemMoved: function() {
          vm.orderResourcesChanged = true;
        },
        orderChanged: function() {
          vm.orderResourcesChanged = true;
        },
        allowDuplicates: false
    };

    vm.saveResourceOrder = function() {
      if( ! vm.orderResourcesChanged )
        return false;

      var resources = [];

      for (var i = 0; i < vm.resourcesOfSelectedCategory.length; i++) {
        resources.push( vm.resourcesOfSelectedCategory[i].id );
      }

      Category.updateResourceOrder( vm.categoryToEdit.id, resources ).then( function() {
        vm.orderResourcesChanged = false;
      });
    };

    vm.newCategory = function() {
      var category = {
        id: null,
        slug: null,
        name: null,
        desc: null,
        resources_count: '0',
        parent_id: vm.categories[0].id //Get the id of the first parent
      };
      vm.categoryToEdit = category;
      vm.categoryToEdit = Category.makeModel(vm.categoryToEdit);
      vm.indexToEdit = null;
    };

    vm.editCategory = function(child, parent) {
      vm.categoryToEdit = child;
      vm.categoryToEdit = Category.makeModel(vm.categoryToEdit);
      vm.categoryToEdit.filter = !!vm.categoryToEdit.filter;
      vm.indexToEdit = {
        parent: vm.categories.indexOf(parent),
        child: parent.children.indexOf(child)
      };

      Category.get( vm.categoryToEdit.slug, {include: 'resources'}).then(function(data) {
        vm.resourcesOfSelectedCategory = data.resources.data;
      });
    };

    vm.onEditSubmit = function() {
      var isNew = ( vm.categoryToEdit.id === null );
      vm.categoryToEdit.save()
        .then( function(data) {
          vm.categoryToEdit = data;
          if( isNew ) {
            vm.categoryToEdit.highlight = true;
            vm.categories[0].children.unshift( vm.categoryToEdit );
          }
          vm.categoryToEdit = null;
        });
    }

    vm.removeCategory = function() {
      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'categoryModal.html',
        controller: 'CategoryModalController',
        controllerAs: 'categoryModalCtrl',
        // size: size,
        resolve: {
          category: function () {
            return vm.categoryToEdit;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.categoryToEdit.remove()
          .then( function() {
            vm.categoryToEdit = null;
            vm.categories[ vm.indexToEdit.parent ].children.splice( vm.indexToEdit.child, 1);
          });
      });

    };

    function init() {
      loadData();
      loadFormFields();
    }

    function mapCategoryIds() {
      var data = [];
      var item = {};
      var children =[];

      for (var i = 0; i < vm.categories.length; i++) {
        item = { id: vm.categories[i].id };
        children = [];
        for (var j = 0; j < vm.categories[i].children.length; j++) {
          children.push( vm.categories[i].children[j].id );
        }
        item.children = children;
        data.push( item );
      }

      return data;
    }

    function loadData() {
      Category.getList({include: "children",toplevel: true}).then( function(data) {
        for (var i = 0; i < data.length; i++) {
          data[i].children = data[i].children.data; //promote the children.data property
        }
        vm.categories = data;
      });
    }

    function loadFormFields() {
      vm.formFields = [
        {
          key: 'name',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Category Name',
            placeholder: 'Enter the short but useful name for this category',
            required: true
          },
          watcher: {
            listener: function() {
              if( vm.categoryToEdit.id === null ) {
                var name = vm.categoryToEdit.name;
                if( name ) {
                  vm.categoryToEdit.slug = Str.toSlug(name);
                }
              }
            }
          }

        },
        {
          key: 'desc',
          type: 'textarea',
          templateOptions: {
            label: 'Description',
            placeholder: 'A description of what this category should hold'
          }
        },
        {
          key: 'slug',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'URL Slug',
            placeholder: 'The link to this category that\'s seen in the URL',
            required: true
          }
        },
        {
          key: 'filter',
          type: 'checkbox',
          templateOptions: {
            label: 'Filterable (Include this category in the filter bar)'
          }
        }
      ];
    }
  }

  angular
    .module('vinelib')
    .controller('CategoryModalController', CategoryModalController);

  /** @ngInject */
  function CategoryModalController($uibModalInstance, category) {
    var vm = this;
    vm.category = category;
    vm.alert = {};

    if( vm.category.resources_count > 0 ) {
      vm.alert.title = 'Can\'t delete while resources belong to this category';
      vm.alert.body = 'This category contains ' + vm.category.resources_count + ' resource(s). Please ensure this category is empty before deleting it.';
      vm.alert.showOk = false;
    } else {
      vm.alert.title = 'Are you sure you want to delete this category';
      vm.alert.body = 'There are currently no resources assigned to this category, so it\'s fine to delete it. Just wanted to check!';
      vm.alert.showOk = true;
    }

    vm.ok = function () {
      $uibModalInstance.close();
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('ConfigController', ConfigController);

  /** @ngInject */
  function ConfigController(Option, optionService) {
    var vm = this;
    vm.options = {};

    init();

    function init() {
      loadOptions();
      loadFormFields();
    }

    vm.onEditSubmit = function() {
      Option.bulkUpdate( vm.options );
    }

    function loadOptions() {
      vm.options = optionService.globalOptions;
    }

    function loadFormFields() {
      vm.formFields = [
        {
          type: 'divider',
          templateOptions: {
            label: 'Homepage Welcome Text'
          }
        },
        {
          key: 'homeWelcomeAlways',
          type: 'editor',
          templateOptions: {
            label: 'Homepage Welcome (Always Display)'
          }
        },
        {
          key: 'homeWelcomeUnauth',
          type: 'editor',
          templateOptions: {
            label: 'Homepage Welcome (Before Login)'
          }
        },
        {
          key: 'homeWelcomeAuth',
          type: 'editor',
          templateOptions: {
            label: 'Homepage Welcome (For Logged-In Users)'
          }
        },
        {
          type: 'divider',
          templateOptions: {
            label: 'Categories'
          }
        },
        {
          key: 'displayResourceCount',
          type: 'checkbox',
          templateOptions: {
            label: 'Display Resource Count next to Categories'
          }
        }
      ];
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('ChangelogController', ChangelogController);

  /** @ngInject */
  function ChangelogController() {
    var vm = this;

    vm.versions = [
      {
        "versionnumber": "1.1.8",
        "date": "2019, August 30",
        "changes": [
          {
            "title": "Change Signup form options as requested",
            "type": "Change",
            "in": "C",
            "desc": "Wording Changes, remove Title, if 'considering', Don't ask for Denomination, don't require website, font changes",
            "job": "email",
            "link": ""
          },
          {
            "title": "Make font larger in para text throughout",
            "type": "Change",
            "in": "C",
            "desc": "Improve readability. Only body text at this point",
            "job": "email",
            "link": ""
          }
        ]
      },
      {
        "versionnumber": "1.1.7",
        "date": "2019, May 23",
        "changes": [
          {
            "title": "Change Signup form options as requested",
            "type": "Change",
            "in": "C",
            "desc": "Allow selection of 'Currently Using TVP', 'Considering Using TVP', 'not yet' and also changed a few options as requested",
            "job": "VINEPA-73",
            "link": ""
          },
          {
            "title": "Prepend 'Currently', 'Considering' using TVP to notes",
            "type": "Change",
            "in": "A",
            "desc": "There is no field to add this new information to, so it's being added to the notes section",
            "job": "VINEPA-73",
            "link": ""
          }
        ]
      },
      {
        "versionnumber": "1.1.6",
        "date": "2017, April 27",
        "changes": [
          {
            "title": "Handle upgrading to Full Member when email exists as Lite Member (subscriber)",
            "type": "Feature",
            "in": "CA",
            "desc": "If a person is currently in the system as a member, and they later fill out the form to become a Full Member when logged out, then they will be sent an email asking them to reset password and be upgraded from then on",
            "job": "VINEPA-72",
            "link": "https://podio.com/elevatecreativecomau/vinegrowers/apps/deliverables/items/22"
          },
          {
            "title": "Join Page Changes",
            "type": "Change",
            "in": "C",
            "desc": "Following the new model of Full Membership or simply subscriber",
            "job": "ELEVATE",
            "link": "https://podio.com/elevatecreativecomau/vinegrowers/apps/deliverables/items/25"
          },
          {
            "title": "Updated body font colour to #4c4c4c",
            "type": "Change",
            "in": "C",
            "desc": "",
            "job": "ELEVATE",
            "link": "https://podio.com/elevatecreativecomau/vinegrowers/apps/deliverables/items/22"
          },
          {
            "title": "Add spinner to password reset pages",
            "type": "Improvement",
            "in": "C",
            "desc": "",
            "job": "VINEPA-67",
            "link": "https://podio.com/elevatecreativecomau/vinegrowers/apps/deliverables/items/22"
          }
        ]
      },
      {
        "versionnumber": "1.1.5",
        "date": "2017, March 16",
        "changes": [
          {
            "title": "Clear 'selected' filter items when clicking",
            "type": "Fix",
            "in": "C",
            "desc": "When an item in the filter is checked, clicking on it now clears the filter and removes the check",
            "job": "VINEPA-65",
            "link": "https://podio.com/tasks/65707968"
          },
          {
            "title": "Change Join Information Page",
            "type": "Change",
            "in": "C",
            "desc": "Remove references to LITE membership. Convert to SUBSCRIBE.",
            "job": "VINEPA-67",
            "link": "https://podio.com/tasks/65569396"
          },
          {
            "title": "Change Join Form for Subscribers",
            "type": "Change",
            "in": "CA",
            "desc": "As requested, Subscribing no longer requires a password",
            "tasks": [
              "Remove Password Field from non-full-member version of form",
              "Change Validation in client form",
              "Update Validation requirements in API",
              "Get API to generate a secure password to stop unauthorised access to that account"
            ],
            "job": "VINEPA-67",
            "link": "https://podio.com/tasks/65569515"
          },
          {
            "title": "Change Upgrade Terminology to Subscribers",
            "type": "Change",
            "in": "C",
            "desc": "As requested, Subscribers don't 'Upgrade' they 'Join'",
            "tasks": [
              "Change Upgrade button on home page",
              "Change 'Join for Free' button on home page to 'Join or Subscribe for free'",
              "Convert Action buttons on resources to reflect Terminology change",
              "Ensure when a user clicks on a resource needing membership, that the signup form opens in 'Full' Mode"
            ],
            "job": "VINEPA-67",
            "link": "https://podio.com/tasks/65569554"
          }
        ]
      },
      {
        "versionnumber": "1.1.4",
        "date": "2017, March 7",
        "changes": [
          {
            "title": "Add Basic Breadcrumb navigation",
            "type": "Feature",
            "in": "C",
            "desc": "Navigating through categories and resources will update the Breadcrumb trail at the top of the page. This helps the user see where they have been. These links can be clicked to take the user back to a previously selected category. The Breadcrumb trail will not display if the user goes directly to the page from a link or bookmark",
            "job": "VINEPA-66",
            "link": ""
          },
          {
            "title": "Make changes to the Resource Filtering System",
            "type": "Change",
            "in": "CA",
            "desc": "As requested, the 'Resource Type' dropdown in the filter bar allows user to select again without clearing filter",
            "tasks": [
              "Change ‘Refine by’ to ‘Filter by’ so users know it is a filter (not a menu)",
              "Highlight selected Resource Type filter by colour (orange) and add a 'tick' icon next to it to indicate it is 'active'",
              "Leave unselected filter items in resource type dropdown available for selection/clicking in black colour",
              "Fixed issue with Filter bar not resetting between category changes"
            ],
            "job": "VINEPA-65",
            "link": "https://podio.com/elevatecreativecomau/vinegrowers/apps/deliverables/items/20"
          },
          {
            "title": "Limit length of slug field",
            "type": "Fix",
            "in": "CA",
            "desc": "When a resource slug was too long the system would appear to take forever to save. Now it comes back with an error so user can fix",
            "job": "VINEPA-61"
          },
          {
            "title": "Add this Changelog page",
            "type": "Feature",
            "desc": "To provide a consistent view of changes, fixes & upgrades to the software",
            "in": "C",
            "job": "VINEPA-68"
          },
          {
            "title": "Partial fix for Long Title Display",
            "type": "Improvement",
            "desc": "Some titles are too long and pushing out the display of resource grid items on some display sizes. This is a partial fix of that problem. Need to also work on locking the image size styling.",
            "in": "C",
            "job": "VINEPA-69",
            "link": "https://podio.com/tasks/64771266"
          }
        ]
      },
      {
        "versionnumber": "1.1.3",
        "date": "2017, February 15",
        "changes": [
          {
            "title": "Need to add past changes at some point"
          }
        ]
      }
    ];
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('AdminresourcesController', AdminresourcesController);

  /** @ngInject */
  function AdminresourcesController(Resource) {
    var vm = this;

    vm.resources = [];
    vm.pagination;

    vm.pageChanged = function() {
      loadResources();
    };

    init();

    function init() {
      loadResources();
    }

    function loadResources() {
      var params = {
        all: true, //return drafts, unpublished, etc
        page: vm.pagination
      }

      return Resource.getList(params).then(function(data){
        vm.resources = data;
      }); 
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .controller('CategoryController', CategoryController);

  /** @ngInject */
  function CategoryController($stateParams, Category) {
    var vm = this;

    loadPagedata();

    function loadPagedata() {
      //Setup query parameters
      var params = {
        include: 'resources.categories'
      }

      //Get data via model
      Category.get($stateParams.categorySlug,params).then(function(data){
        vm.category = data;
        vm.resources = data.resources.data;
      });        
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgSidebar', vgSidebar);

  /** @ngInject */
  function vgSidebar() {
    var directive = {
      restrict: 'E',
      scope: {
          // sidebarSlug: '@sidebarSlug',
          // templateType: '@templateType'
      },
      templateUrl: 'app/components/sidebar/sidebar.html',
      controller: SidebarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController() {
      // var vm = this;

      // Category.get(vm.sidebarSlug, {include: "children"})
      //   .then(function(data){
      //     vm.parent = data;
      //     vm.categories = vm.parent.children.data;
      //   });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgResourceGrid', vgResourceGrid);

  /** @ngInject */
  function vgResourceGrid() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/resourceGrid/resourceGrid.html',
      scope: {
          resources: '=',
          showFilter: '='
      },
      controller: ResourceGridController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ResourceGridController(Str, $state, modalService, categoryService, $scope, $rootScope) {
      var vm = this;
      vm.availableTypes = categoryService.availableTypes;
      vm.fltr = {
        types: categoryService.availableTypes,
        buttons: [],
        filtered: 0
      };
      vm.filterData = {
        "type": null,
        "category": null,
        "orderBy": null
      };
      vm.firstLoad = true;

      init();

      vm.getButtonText = function( resource ) {
        var action = vm.availableTypes[ resource.type ].text;

        if( resource.availability === 'access' )
          return action + ' Now';
        
        if( resource.availability === 'upgrade' )
          return 'Join as Full Member to ' + action;

        return 'Join to ' + action;
      }

      vm.resourceAction = function( $event, resource ) {
        $event.preventDefault();
        if( resource.availability === 'access' ) {
          $state.go( 'resource', { resourceSlug: resource.slug } );
        } else if( resource.availability === 'upgrade' ) {
          vm.openUpgrade();
        } else {
          vm.openSignup();
        }
      }

      vm.buttonClass = function( resource ) {
        if( resource.availability === 'access' )
          return 'btn-info';

        return 'btn-warning';
      }

      vm.capitalise = function( string ) {
        return Str.toUpperFirstChar( string );
      }

      //APFix: need to move this to parent controller or service
      vm.openSignup = function() {
        var modalOptions = {
            headerText: 'Become a member of The Vine Project Resource Library for Free',
            bodyTemplate: '/formFull.html'
        };

        modalService.show({}, modalOptions);
      }

      vm.openUpgrade = function() {
        var modalOptions = {
            headerText: 'Upgrade to a full membership for Free',
            bodyTemplate: '/formUpgrade.html'
        };

        modalService.show({}, modalOptions);
      }

      // vm.disableType = function (type) {
      //   return ( vm.fltr.types.indexOf( type ) === -1 );
      // }

      vm.filterBar = function (row) {

        if( vm.filterData.type ) {
          if( vm.filterData.type !== row.type )
            return false;
        }

        if( vm.filterData.category ) {
          if( row.filterCats.indexOf( vm.filterData.category ) === -1 )
            return false;
        }
        getFilterDataFromResource( row );
        return true;

      };

      vm.filter = function( group, value, selectedItem ) {
        if( group === 'type') {
          //Stop inactive links from filtering
          if( ! selectedItem.state ) {
            return false;
          }
          if( selectedItem.selected === true ) { //clear if already selected
            markAsSelected( );
          } else {
            markAsSelected( selectedItem );
          }
        }

        vm.firstLoad = false;
        // resetTypeStates();
        vm.fltr.buttons = [];
        if( value === 'clear' ) {
          clearFilter();
        } else if(vm.filterData[group] === value) {
          vm.filterData[group] = null;
          vm.fltr.filtered --;
        } else {
          vm.filterData[group] = value;
          vm.fltr.filtered ++;
        }
      }

      //Wait for the resource data to turn up and then prepare the filter data
      $scope.$watch(angular.bind(vm, function () {
        return vm.resources;
      }), function (resources) {
        if( angular.isDefined( resources ) )
          prepareFilterData();
      });

      function prepareFilterData() {
        //ensure the resource type list is reset before getting resource values
        angular.forEach( vm.fltr.types, function( value ) {
          value.state = false;
        });
        for (var i = 0; i < vm.resources.length; i++) {
          getFilterDataFromResource( vm.resources[i] );
        }
      }

      function getFilterDataFromResource( resource ) {
        resource.filterCats = [];
        if( angular.isDefined( resource.categories ) ) {
          for (var n = resource.categories.data.length - 1; n >= 0; n--) {
            if( resource.categories.data[n].filter ) {
              resource.filterCats.push( resource.categories.data[n].slug );
              if( resource.categories.data[n].filter === 1 && ! isInArray( vm.fltr.buttons, resource.categories.data[n], 'slug' ) )
                vm.fltr.buttons.push( resource.categories.data[n] );
            }
          }
          //We only define available types on the first load
          if( vm.firstLoad ) {
            vm.fltr.types[ resource.type ].state = true;
          }
        }
      }

      function isInArray( haystack, needle, key ) {
        for (var i = haystack.length - 1; i >= 0; i--) {
          if( needle[key] === haystack[i][key] )
            return true;
        }
        return false;
      }

      function clearFilter() {
        angular.forEach( vm.filterData, function( v, k ) {
            vm.filterData[k] = null;
          });
          vm.fltr.filtered = 0;
          markAsSelected();
      }

      function markAsSelected( selectedItem ) {
        var type = selectedItem ? selectedItem.type : 'none';
        angular.forEach( vm.availableTypes, function( value, key ) {
          value.selected = ( type === key );
        });
      }

      function init() {
        var removeStateWatch = $rootScope.$on('$stateChangeSuccess', function(){
          clearFilter();
          vm.firstLoad = true;
          prepareFilterData();
        });

        vm.$onDestroy = function () {
          removeStateWatch();
        }
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vineNavbar', vineNavbar);

  /** @ngInject */
  function vineNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($rootScope, modalService, $state, userService, categoryService, $aside, $timeout) {
      var vm = this;
      vm.user = userService.currentUser;
      vm.modalInstance;
      vm.currentMenuOpen = null;
      vm.searchOpen = false;
      vm.searchTerm;
      vm.loginData = {};
      vm.breadCrumb = [];
      vm.breadCrumbReindexed = [];

      init();

      //APFix: need to move this to parent controller or service
      vm.openLogin = function () {
        vm.closeMenu();
        modalService.close();
        var modalOptions = {
            headerText: 'Login to the Resource Library',
            bodyTemplate: '/loginTemplate.html',
            user: {}
        };

        vm.modalInstance = modalService.show({}, modalOptions);
      };

      // vm.chooseMemberType = function(memberType) {
      //   modalService.close();
      //   var modalOptions = {
      //       headerText: 'Become a member of The Vine Project Resource Library for Free',
      //       bodyTemplate: '/formSignup.html',
      //       memberType: memberType
      //   };

      //   modalService.show({}, modalOptions);
      // }

      vm.performSearch = function() {
        vm.searchOpen = false;
        vm.closeMenu();
        $state.go('search', {searchTerm: vm.searchTerm});
      }

      vm.loginFields = [
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile'],
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            required: true
          }
        },
        {
          key: 'password',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile'],
            type: 'password',
            label: 'Password',
            required: true
          }
        }
      ];

      vm.loginMessage;

      vm.submitLoginForm = function() {
        var promise = userService.login( vm.loginData );
        vm.loginMessage = null;

        promise.then(function() {
          vm.loginClass = 'alert-success';
          vm.loginMessage = 'Success';
          $timeout( function(){
            modalService.close();
            vm.loginData = {};
            vm.loginMessage = null;
             $state.go('home');
          }, 1000 );
        }, function(response) {
          vm.loginClass = 'alert-danger';
          vm.loginMessage = response.message;
        });
      }
    
      vm.logoutUser = function () {
        vm.closeMenu();
        userService.logout();
      }

      //APFix: Duplicated
      vm.openSignup = function() {
        modalService.close();
        var modalOptions = {
            headerText: 'Become a member of The Vine Project Resource Library for Free',
            bodyTemplate: '/formSignup.html'
        };

        modalService.show({}, modalOptions);
      }
      
      vm.toggleMenuItem = function(slug) {
        vm.currentMenuOpen = (vm.currentMenuOpen === slug ) ? null : slug;
      }

      vm.openMenu = function(placement, backdrop) {

        vm.modalInstance = $aside.open({
          templateUrl: 'app/components/navbar/menu.html',
          placement: placement,
          size: 'sm',
          backdrop: backdrop
        });

      }

      //APFix - should probably introduce a global stateful way of doing this
      vm.closeMenu = function() {
        if( vm.modalInstance )
          vm.modalInstance.close();
      }

      function buildBreadCrumb( state ) {
        var o = state.tvpCrumb;
        var crumb = {};

        if( angular.isUndefined( o ) )
          return false;

        if( o.label === ":categorySlug" ) {
          crumb.object = categoryService.searchBySlug( $state.params.categorySlug );
          crumb.name = ( crumb.object.name ) ? crumb.object.name : $state.params.categorySlug;
          if( o.level === 0 ) {
            crumb.link = $state.href('home', {"categorySlug":$state.params.categorySlug},{"absolute":true});
          } else {
            crumb.link = $state.href('category', {"categorySlug":$state.params.categorySlug},{"absolute":true});
            if( crumb.object.parent ) {
              vm.breadCrumb[ o.level - 1 ] = {
                name: crumb.object.parent.name,
                link: $state.href('home', {"categorySlug":crumb.object.parent.slug},{"absolute":true})
              };
            }
          }
        } else if( o.label === ":resourceSlug" ) {
          crumb.name = $state.params.resourceSlug;
          crumb.link = null;
        } else {
          crumb.name = o.label;
          crumb.link = o.link ? $state.href(o.link) : null;
        }

        vm.breadCrumb[ o.level ] = crumb;

        if( o.level > 0 && o.parent ) {
          vm.breadCrumb[ o.level - 1 ] = o.parent;
        }

        vm.breadCrumb = vm.breadCrumb.slice(0, o.level + 1);
        vm.breadCrumbReindexed = vm.breadCrumb.filter(function(val){return val});
      }

      function init() {
        vm.categories = categoryService.menuCategories;
        
        var removeStateWatch = $rootScope.$on('$stateChangeStart', function(){
          modalService.close();
        });

        var removeStateSuccessWatch = $rootScope.$on('$stateChangeSuccess', function(){
          buildBreadCrumb( $state.current );
        });

        vm.$onDestroy = function () {
          removeStateWatch();
          removeStateSuccessWatch();
        }
      }
    }
  }

})();
(function() {
  'use strict';

  angular
  .module('vinelib')
  .config(config);

  config.$inject = ['formlyConfigProvider'];
  /* @ngInject */
  function config(formlyConfigProvider) {
    "ngInject";
    /**
     * Add Field Type 'Description'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'description',
      templateUrl: 'app/components/forms/description.html',
      wrapper: ['bootstrapLabel']
    });

    /**
     * Add Field Type 'editor'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'editor',
      templateUrl: 'app/components/forms/editor.html',
      wrapper: ['bootstrapLabel']
    });

    /**
     * Add Field Type 'ReadOnly'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'readonly',
      templateUrl: 'app/components/forms/readonly.html'
    });

    /**
     * Add Field Type 'Divider'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'divider',
      templateUrl: 'app/components/forms/divider.html'
    });

    /**
     * Add Field Type 'Upload'
     * @type {String}
     */
    formlyConfigProvider.setType({
      name: 'upload',
      extends: 'input',
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      link: function(scope, el) {
        el.on("change", function(changeEvent) {
          var emitEventName = scope.options.templateOptions.event ? scope.options.templateOptions.event : 'fileToUpload';
          var file = changeEvent.target.files[0];
          if (file) {
            scope.$emit(emitEventName, file);
            var fileProp = {};
            for (var properties in file) {
              if (!angular.isFunction(file[properties])) {
                fileProp[properties] = file[properties];
              }
            }
            scope.fc.$setViewValue(fileProp);
          } else {
            scope.fc.$setViewValue(undefined);
          }
        });
        el.on("focusout", function() {
          scope.fc.$validate();
        });
        
      },
      defaultOptions: {
        templateOptions: {
          type: 'file',
          required: true
        }
      }
    });
  }
})();
(function() {
  'use strict';

  angular.module('vinelib').service('modalService', modalService);
  
  /** @ngInject */
  function modalService($uibModal) {

    var modalDefaults = {
        backdrop: true,
        keyboard: true,
        modalFade: true,
        templateUrl: 'app/components/modal/modal.html'
    };

    var modalOptions = {
        headerText: 'Title'
    };

    var modalInstance;

    this.show = function (customModalDefaults, customModalOptions) {
        //Create temp objects to work with since we're in a singleton service
        var tempModalDefaults = {};
        var tempModalOptions = {};

        //Map angular-ui modal custom defaults to modal defaults defined in service
        angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

        //Map modal.html $scope custom properties to defaults defined in service
        angular.extend(tempModalOptions, modalOptions, customModalOptions);

        if (!tempModalDefaults.controller) {
            tempModalDefaults.controller = function ($scope, $uibModalInstance) {
                $scope.modalOptions = tempModalOptions;
                $scope.modalOptions.ok = function (result) {
                    $uibModalInstance.close(result);
                };
                $scope.modalOptions.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        }

        modalInstance = $uibModal.open(tempModalDefaults);//.result;
        return modalInstance;
    };

    this.close = function() {
        if( modalInstance )
            modalInstance.close();
    }
  }
})();
(function() {
  'use strict';

  angular
  .module('vinelib')
  .directive('vgFormSignup', vgFormSignup);

  /** @ngInject */
  function vgFormSignup() {
    var directive = {
      restrict: 'E',
      scope: {
        categorySlug: '@categorySlug',
        templateType: '@templateType',
        formType: '@'
      },
      templateUrl: 'app/components/formSignup/formSignup.html',
      controller: formSignupController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function formSignupController( $log, modalService, userService, $location, $anchorScroll, usSpinnerService, $state, $window ) {
      var vm = this;

      function init() {
        vm.user = userService.currentUser;

        if( vm.formType == 'profile' ) {
          //don't change any settings
        } else if( vm.formType == 'upgrade' ) { //Set to upgrade by default
            vm.user.user.fullMember = 'considering';
        } else if( vm.formType == 'full' ) { //Set to full membership type, but still use signup form
            vm.formType = 'signup';
            vm.user.user.fullMember = 'considering';
        } else {
          vm.user.user.fullMember = false;
        }

        //Subscribe by default
        if( vm.user.loggedIn !== true ) { //if this is a new form, then set defaults
            vm.user.user.subscribeGotherefor = true;
            vm.user.user.shareEmail = true;
        }

        vm.userFields = chooseFields();

        vm.user.user.statesFieldHasOptions = false;

      }

      //APFix: need to move this to parent controller or service
      vm.openLogin = function () {
        modalService.close();

        var modalOptions = {
            headerText: 'Login to the Resource Library',
            bodyTemplate: '/loginTemplate.html',
            user: {}
        };

        vm.modalInstance = modalService.show({}, modalOptions);

        vm.modalInstance.result.then(function (result) {
          if( typeof result === 'undefined' || typeof result.email === 'undefined' || typeof result.password === 'undefined' ) {
            $log.error("There was a problem with the login data");
            return false;
          }

          userService.login(result);
        });
      };

      var timeframeOptions = [
        {option: 'started', label:'I have already started'},
        {option: 'month', label:'Within a month'},
        {option: '3months', label:'Within 3 months'},
        {option: '6months', label:'Within 3-6 months'},
        {option: '12months', label:'Within 6-12 months'},
        {option: 'over12m', label:'After 12 months'}
      ];

      var roleOptions = [
        {option: "Senior Pastor/Minister"},
        {option: "Associate Pastor/Minister"},
        {option: "Women's Pastor/Minister"},
        {option: "Youth/Kids Pastor/Minister"},
        {option: "Student Pastor/Minister"},
        {option: "Elder/Lay leader"},
        {option: "Bishop"},
        {option: "Staff"},
        {option: "Trainee"},
        {option: "Board Member"},
        {option: "Director"},
        {option: "Principal"},
        {option: "Campus Staff Worker"},
        {option: "Other"}
      ];

      var denominationOptions = [
        {option: "Adventist"},
        {option: "Anglican"},
        {option: "Baptist"},
        {option: "Brethren"},
        {option: "Church of Christ"},
        {option: "Christian Reformed"},
        {option: "Congregational"},
        {option: "Episcopalian"},
        {option: "Evangelical Free Churches"},
        {option: "FIEC"},
        {option: "Lutheran"},
        {option: "Methodist"},
        {option: "Pentecostal"},
        {option: "Presbyterian"},
        {option: "Reformed"},
        {option: "Roman Catholic"},
        {option: "Southern Baptist"},
        {option: "Uniting"},
        {option: "Independent/non-denominational"},
        {option: "Parachurch"},
        {option: "Other"}
      ];

      var countryOptions = [
        {option: 'AU', label: "Australia"},
        {option: 'GB', label: "United Kingdom"},
        {option: 'US', label: "United States"},
        {option: '',   label: "=============="},
        {option: 'AF', label: "Afghanistan"},
        {option: 'AL', label: "Albania"},
        {option: 'DZ', label: "Algeria"},
        {option: 'AS', label: "American Samoa"},
        {option: 'AD', label: "Andorra"},
        {option: 'AO', label: "Angola"},
        {option: 'AI', label: "Anguilla"},
        {option: 'AQ', label: "Antarctica"},
        {option: 'AG', label: "Antigua And Barbuda"},
        {option: 'AR', label: "Argentina"},
        {option: 'AM', label: "Armenia"},
        {option: 'AW', label: "Aruba"},
        {option: 'AU', label: "Australia"},
        {option: 'AT', label: "Austria"},
        {option: 'AZ', label: "Azerbaijan"},
        {option: 'BS', label: "Bahamas"},
        {option: 'BH', label: "Bahrain"},
        {option: 'BD', label: "Bangladesh"},
        {option: 'BB', label: "Barbados"},
        {option: 'BY', label: "Belarus"},
        {option: 'BE', label: "Belgium"},
        {option: 'BZ', label: "Belize"},
        {option: 'BJ', label: "Benin"},
        {option: 'BM', label: "Bermuda"},
        {option: 'BT', label: "Bhutan"},
        {option: 'BO', label: "Bolivia"},
        {option: 'BA', label: "Bosnia And Herzegowina"},
        {option: 'BW', label: "Botswana"},
        {option: 'BV', label: "Bouvet Island"},
        {option: 'BR', label: "Brazil"},
        {option: 'IO', label: "British Indian Ocean Territory"},
        {option: 'BN', label: "Brunei Darussalam"},
        {option: 'BG', label: "Bulgaria"},
        {option: 'BF', label: "Burkina Faso"},
        {option: 'BI', label: "Burundi"},
        {option: 'KH', label: "Cambodia"},
        {option: 'CM', label: "Cameroon"},
        {option: 'CA', label: "Canada"},
        {option: 'CV', label: "Cape Verde"},
        {option: 'KY', label: "Cayman Islands"},
        {option: 'CF', label: "Central African Republic"},
        {option: 'TD', label: "Chad"},
        {option: 'CL', label: "Chile"},
        {option: 'CN', label: "China"},
        {option: 'CX', label: "Christmas Island"},
        {option: 'CC', label: "Cocos (Keeling) Islands"},
        {option: 'CO', label: "Colombia"},
        {option: 'KM', label: "Comoros"},
        {option: 'CG', label: "Congo"},
        {option: 'CD', label: "Congo, The Democratic Republic Of The"},
        {option: 'CK', label: "Cook Islands"},
        {option: 'CR', label: "Costa Rica"},
        {option: 'CI', label: "Cote D'Ivoire"},
        {option: 'HR', label: "Croatia (Local Name: Hrvatska)"},
        {option: 'CU', label: "Cuba"},
        {option: 'CY', label: "Cyprus"},
        {option: 'CZ', label: "Czech Republic"},
        {option: 'DK', label: "Denmark"},
        {option: 'DJ', label: "Djibouti"},
        {option: 'DM', label: "Dominica"},
        {option: 'DO', label: "Dominican Republic"},
        {option: 'TL', label: "Timor-Leste (East Timor)"},
        {option: 'EC', label: "Ecuador"},
        {option: 'EG', label: "Egypt"},
        {option: 'SV', label: "El Salvador"},
        {option: 'GQ', label: "Equatorial Guinea"},
        {option: 'ER', label: "Eritrea"},
        {option: 'EE', label: "Estonia"},
        {option: 'ET', label: "Ethiopia"},
        {option: 'FK', label: "Falkland Islands (Malvinas)"},
        {option: 'FO', label: "Faroe Islands"},
        {option: 'FJ', label: "Fiji"},
        {option: 'FI', label: "Finland"},
        {option: 'FR', label: "France"},
        {option: 'FX', label: "France, Metropolitan"},
        {option: 'GF', label: "French Guiana"},
        {option: 'PF', label: "French Polynesia"},
        {option: 'TF', label: "French Southern Territories"},
        {option: 'GA', label: "Gabon"},
        {option: 'GM', label: "Gambia"},
        {option: 'GE', label: "Georgia"},
        {option: 'DE', label: "Germany"},
        {option: 'GH', label: "Ghana"},
        {option: 'GI', label: "Gibraltar"},
        {option: 'GR', label: "Greece"},
        {option: 'GL', label: "Greenland"},
        {option: 'GD', label: "Grenada"},
        {option: 'GP', label: "Guadeloupe"},
        {option: 'GU', label: "Guam"},
        {option: 'GT', label: "Guatemala"},
        {option: 'GN', label: "Guinea"},
        {option: 'GW', label: "Guinea-Bissau"},
        {option: 'GY', label: "Guyana"},
        {option: 'HT', label: "Haiti"},
        {option: 'HM', label: "Heard And Mc Donald Islands"},
        {option: 'VA', label: "Holy See (Vatican City State)"},
        {option: 'HN', label: "Honduras"},
        {option: 'HK', label: "Hong Kong"},
        {option: 'HU', label: "Hungary"},
        {option: 'IS', label: "Iceland"},
        {option: 'IN', label: "India"},
        {option: 'ID', label: "Indonesia"},
        {option: 'IR', label: "Iran (Islamic Republic Of)"},
        {option: 'IQ', label: "Iraq"},
        {option: 'IE', label: "Ireland"},
        {option: 'IL', label: "Israel"},
        {option: 'IT', label: "Italy"},
        {option: 'JM', label: "Jamaica"},
        {option: 'JP', label: "Japan"},
        {option: 'JO', label: "Jordan"},
        {option: 'KZ', label: "Kazakhstan"},
        {option: 'KE', label: "Kenya"},
        {option: 'KI', label: "Kiribati"},
        {option: 'KP', label: "Korea, Democratic People's Republic Of"},
        {option: 'KR', label: "Korea, Republic Of"},
        {option: 'KW', label: "Kuwait"},
        {option: 'KG', label: "Kyrgyzstan"},
        {option: 'LA', label: "Lao People's Democratic Republic"},
        {option: 'LV', label: "Latvia"},
        {option: 'LB', label: "Lebanon"},
        {option: 'LS', label: "Lesotho"},
        {option: 'LR', label: "Liberia"},
        {option: 'LY', label: "Libyan Arab Jamahiriya"},
        {option: 'LI', label: "Liechtenstein"},
        {option: 'LT', label: "Lithuania"},
        {option: 'LU', label: "Luxembourg"},
        {option: 'MO', label: "Macau"},
        {option: 'MK', label: "Macedonia, Former Yugoslav Republic Of"},
        {option: 'MG', label: "Madagascar"},
        {option: 'MW', label: "Malawi"},
        {option: 'MY', label: "Malaysia"},
        {option: 'MV', label: "Maldives"},
        {option: 'ML', label: "Mali"},
        {option: 'MT', label: "Malta"},
        {option: 'MH', label: "Marshall Islands"},
        {option: 'MQ', label: "Martinique"},
        {option: 'MR', label: "Mauritania"},
        {option: 'MU', label: "Mauritius"},
        {option: 'YT', label: "Mayotte"},
        {option: 'MX', label: "Mexico"},
        {option: 'FM', label: "Micronesia, Federated States Of"},
        {option: 'MD', label: "Moldova, Republic Of"},
        {option: 'MC', label: "Monaco"},
        {option: 'MN', label: "Mongolia"},
        {option: 'ME', label: "Montenegro"},
        {option: 'MS', label: "Montserrat"},
        {option: 'MA', label: "Morocco"},
        {option: 'MZ', label: "Mozambique"},
        {option: 'MM', label: "Myanmar"},
        {option: 'NA', label: "Namibia"},
        {option: 'NR', label: "Nauru"},
        {option: 'NP', label: "Nepal"},
        {option: 'NL', label: "Netherlands"},
        {option: 'AN', label: "Netherlands Antilles"},
        {option: 'NC', label: "New Caledonia"},
        {option: 'NZ', label: "New Zealand"},
        {option: 'NI', label: "Nicaragua"},
        {option: 'NE', label: "Niger"},
        {option: 'NG', label: "Nigeria"},
        {option: 'NU', label: "Niue"},
        {option: 'NF', label: "Norfolk Island"},
        {option: 'MP', label: "Northern Mariana Islands"},
        {option: 'NO', label: "Norway"},
        {option: 'OM', label: "Oman"},
        {option: 'PK', label: "Pakistan"},
        {option: 'PW', label: "Palau"},
        {option: 'PA', label: "Panama"},
        {option: 'PG', label: "Papua New Guinea"},
        {option: 'PY', label: "Paraguay"},
        {option: 'PE', label: "Peru"},
        {option: 'PH', label: "Philippines"},
        {option: 'PN', label: "Pitcairn"},
        {option: 'PL', label: "Poland"},
        {option: 'PT', label: "Portugal"},
        {option: 'PR', label: "Puerto Rico"},
        {option: 'QA', label: "Qatar"},
        {option: 'RE', label: "Reunion"},
        {option: 'RO', label: "Romania"},
        {option: 'RU', label: "Russian Federation"},
        {option: 'RW', label: "Rwanda"},
        {option: 'KN', label: "Saint Kitts And Nevis"},
        {option: 'LC', label: "Saint Lucia"},
        {option: 'VC', label: "Saint Vincent And The Grenadines"},
        {option: 'WS', label: "Samoa"},
        {option: 'SM', label: "San Marino"},
        {option: 'ST', label: "Sao Tome And Principe"},
        {option: 'SA', label: "Saudi Arabia"},
        {option: 'SN', label: "Senegal"},
        {option: 'SR', label: "Serbia"},
        {option: 'SC', label: "Seychelles"},
        {option: 'SL', label: "Sierra Leone"},
        {option: 'SG', label: "Singapore"},
        {option: 'SK', label: "Slovakia (Slovak Republic)"},
        {option: 'SI', label: "Slovenia"},
        {option: 'SB', label: "Solomon Islands"},
        {option: 'SO', label: "Somalia"},
        {option: 'ZA', label: "South Africa"},
        {option: 'GS', label: "South Georgia, South Sandwich Islands"},
        {option: 'SS', label: "South Sudan"},
        {option: 'ES', label: "Spain"},
        {option: 'LK', label: "Sri Lanka"},
        {option: 'SH', label: "St. Helena"},
        {option: 'PM', label: "St. Pierre And Miquelon"},
        {option: 'SD', label: "Sudan"},
        {option: 'SR', label: "Suriname"},
        {option: 'SJ', label: "Svalbard And Jan Mayen Islands"},
        {option: 'SZ', label: "Swaziland"},
        {option: 'SE', label: "Sweden"},
        {option: 'CH', label: "Switzerland"},
        {option: 'SY', label: "Syrian Arab Republic"},
        {option: 'TW', label: "Taiwan"},
        {option: 'TJ', label: "Tajikistan"},
        {option: 'TZ', label: "Tanzania, United Republic Of"},
        {option: 'TH', label: "Thailand"},
        {option: 'TG', label: "Togo"},
        {option: 'TK', label: "Tokelau"},
        {option: 'TO', label: "Tonga"},
        {option: 'TT', label: "Trinidad And Tobago"},
        {option: 'TN', label: "Tunisia"},
        {option: 'TR', label: "Turkey"},
        {option: 'TM', label: "Turkmenistan"},
        {option: 'TC', label: "Turks And Caicos Islands"},
        {option: 'TV', label: "Tuvalu"},
        {option: 'UG', label: "Uganda"},
        {option: 'UA', label: "Ukraine"},
        {option: 'AE', label: "United Arab Emirates"},
        {option: 'GB', label: "United Kingdom"},
        {option: 'US', label: "United States"},
        {option: 'UM', label: "United States Minor Outlying Islands"},
        {option: 'UY', label: "Uruguay"},
        {option: 'UZ', label: "Uzbekistan"},
        {option: 'VU', label: "Vanuatu"},
        {option: 'VE', label: "Venezuela"},
        {option: 'VN', label: "Viet Nam"},
        {option: 'VG', label: "Virgin Islands (British)"},
        {option: 'VI', label: "Virgin Islands (U.S.)"},
        {option: 'WF', label: "Wallis And Futuna Islands"},
        {option: 'EH', label: "Western Sahara"},
        {option: 'YE', label: "Yemen"},
        {option: 'YU', label: "Yugoslavia"},
        {option: 'ZM', label: "Zambia"},
        {option: 'ZW', label: "Zimbabwe"}
      ];

      var stateOptions = [];

      var countryStates = {
        US: [
          {option: 'AL', label: "Alabama"},
          {option: 'AK', label: "Alaska"},
          {option: 'AZ', label: "Arizona"},
          {option: 'AR', label: "Arkansas"},
          {option: 'CA', label: "California"},
          {option: 'CO', label: "Colorado"},
          {option: 'CT', label: "Connecticut"},
          {option: 'DE', label: "Delaware"},
          {option: 'DC', label: "District of Columbia"},
          {option: 'FL', label: "Florida"},
          {option: 'GA', label: "Georgia"},
          {option: 'HI', label: "Hawaii"},
          {option: 'ID', label: "Idaho"},
          {option: 'IL', label: "Illinois"},
          {option: 'IN', label: "Indiana"},
          {option: 'IA', label: "Iowa"},
          {option: 'KS', label: "Kansas"},
          {option: 'KY', label: "Kentucky"},
          {option: 'LA', label: "Louisiana"},
          {option: 'ME', label: "Maine"},
          {option: 'MD', label: "Maryland"},
          {option: 'MA', label: "Massachusetts"},
          {option: 'MI', label: "Michigan"},
          {option: 'MN', label: "Minnesota"},
          {option: 'MS', label: "Mississippi"},
          {option: 'MO', label: "Missouri"},
          {option: 'MT', label: "Montana"},
          {option: 'NE', label: "Nebraska"},
          {option: 'NV', label: "Nevada"},
          {option: 'NH', label: "New Hampshire"},
          {option: 'NJ', label: "New Jersey"},
          {option: 'NM', label: "New Mexico"},
          {option: 'NY', label: "New York"},
          {option: 'NC', label: "North Carolina"},
          {option: 'ND', label: "North Dakota"},
          {option: 'OH', label: "Ohio"},
          {option: 'OK', label: "Oklahoma"},
          {option: 'OR', label: "Oregon"},
          {option: 'PA', label: "Pennsylvania"},
          {option: 'RI', label: "Rhode Island"},
          {option: 'SC', label: "South Carolina"},
          {option: 'SD', label: "South Dakota"},
          {option: 'TN', label: "Tennessee"},
          {option: 'TX', label: "Texas"},
          {option: 'UT', label: "Utah"},
          {option: 'VT', label: "Vermont"},
          {option: 'VA', label: "Virginia"},
          {option: 'WA', label: "Washington"},
          {option: 'WV', label: "West Virginia"},
          {option: 'WI', label: "Wisconsin"},
          {option: 'WY', label: "Wyoming"}
        ],
        AU: [
          {option: 'NSW', label: "New South Wales"},
          {option: 'VIC', label: "Victoria"},
          {option: 'QLD', label: "Queensland"},
          {option: 'SA', label: "South Australia"},
          {option: 'NT', label: "Northern Territory"},
          {option: 'ACT', label: "Australian Capital Territory"},
          {option: 'WA', label: "Western Australia"},
          {option: 'TAS', label: "Tasmania"}
        ],
        GB: [
          {option: 'englandBathAndNorthEastSomerset',        label: 'England - Bath and North East Somerset'},
          {option: 'englandBedfordshire',                    label: 'England - Bedfordshire'},
          {option: 'englandBlackburnWithDarwen',             label: 'England - Blackburn with Darwen'},
          {option: 'englandBlackpool',                       label: 'England - Blackpool'},
          {option: 'englandBournemouth',                     label: 'England - Bournemouth'},
          {option: 'englandBracknellForest',                 label: 'England - Bracknell Forest'},
          {option: 'englandBrightonAndHove',                 label: 'England - Brighton and Hove'},
          {option: 'englandBristol',                         label: 'England - Bristol'},
          {option: 'englandBuckinghamshire',                 label: 'England - Buckinghamshire'},
          {option: 'englandCambridgeshire',                  label: 'England - Cambridgeshire'},
          {option: 'englandCheshire',                        label: 'England - Cheshire'},
          {option: 'englandCornwall',                        label: 'England - Cornwall'},
          {option: 'englandCumbria',                         label: 'England - Cumbria'},
          {option: 'englandDarlington',                      label: 'England - Darlington'},
          {option: 'englandDerby',                           label: 'England - Derby'},
          {option: 'englandDerbyshire',                      label: 'England - Derbyshire'},
          {option: 'englandDevon',                           label: 'England - Devon'},
          {option: 'englandDorset',                          label: 'England - Dorset'},
          {option: 'englandDurham',                          label: 'England - Durham'},
          {option: 'englandEastRidingOfYorkshire',           label: 'England - East Riding of Yorkshire'},
          {option: 'englandEastSussex',                      label: 'England - East Sussex'},
          {option: 'englandEssex',                           label: 'England - Essex'},
          {option: 'englandGloucestershire',                 label: 'England - Gloucestershire'},
          {option: 'englandGreaterManchester',               label: 'England - Greater Manchester'},
          {option: 'englandHalton',                          label: 'England - Halton'},
          {option: 'englandHampshire',                       label: 'England - Hampshire'},
          {option: 'englandHartlepool',                      label: 'England - Hartlepool'},
          {option: 'englandHerefordshire',                   label: 'England - Herefordshire'},
          {option: 'englandHertfordshire',                   label: 'England - Hertfordshire'},
          {option: 'englandIsleOfWight',                     label: 'England - Isle of Wight'},
          {option: 'englandKent',                            label: 'England - Kent'},
          {option: 'englandKingstonUponHull',                label: 'England - Kingston upon Hull'},
          {option: 'englandLancashire',                      label: 'England - Lancashire'},
          {option: 'englandLeicester',                       label: 'England - Leicester'},
          {option: 'englandLeicestershire',                  label: 'England - Leicestershire'},
          {option: 'englandLincolnshire',                    label: 'England - Lincolnshire'},
          {option: 'englandLondon',                          label: 'England - London'},
          {option: 'englandLuton',                           label: 'England - Luton'},
          {option: 'englandMerseyside',                      label: 'England - Merseyside'},
          {option: 'englandMiddlesbrough',                   label: 'England - Middlesbrough'},
          {option: 'englandMiltonKeynes',                    label: 'England - Milton Keynes'},
          {option: 'englandNorfolk',                         label: 'England - Norfolk'},
          {option: 'englandNorthEastLincolnshire',           label: 'England - North East Lincolnshire'},
          {option: 'englandNorthLincolnshire',               label: 'England - North Lincolnshire'},
          {option: 'englandNorthSomerset',                   label: 'England - North Somerset'},
          {option: 'englandNorthYorkshire',                  label: 'England - North Yorkshire'},
          {option: 'englandNorthamptonshire',                label: 'England - Northamptonshire'},
          {option: 'englandNorthumberland',                  label: 'England - Northumberland'},
          {option: 'englandNottingham',                      label: 'England - Nottingham'},
          {option: 'englandNottinghamshire',                 label: 'England - Nottinghamshire'},
          {option: 'englandOxfordshire',                     label: 'England - Oxfordshire'},
          {option: 'englandPeterborough',                    label: 'England - Peterborough'},
          {option: 'englandPlymouth',                        label: 'England - Plymouth'},
          {option: 'englandPoole',                           label: 'England - Poole'},
          {option: 'englandPortsmouth',                      label: 'England - Portsmouth'},
          {option: 'englandReading',                         label: 'England - Reading'},
          {option: 'englandRedcarAndCleveland',              label: 'England - Redcar and Cleveland'},
          {option: 'englandRutland',                         label: 'England - Rutland'},
          {option: 'englandShropshire',                      label: 'England - Shropshire'},
          {option: 'englandSlough',                          label: 'England - Slough'},
          {option: 'englandSomerset',                        label: 'England - Somerset'},
          {option: 'englandSouthGloucestershire',            label: 'England - South Gloucestershire'},
          {option: 'englandSouthYorkshire',                  label: 'England - South Yorkshire'},
          {option: 'englandSouthampton',                     label: 'England - Southampton'},
          {option: 'englandSouthendOnSea',                   label: 'England - Southend-on-Sea'},
          {option: 'englandStaffordshire',                   label: 'England - Staffordshire'},
          {option: 'englandStocktonOnTees',                  label: 'England - Stockton-on-Tees'},
          {option: 'englandStokeOnTrent',                    label: 'England - Stoke-on-Trent'},
          {option: 'englandSuffolk',                         label: 'England - Suffolk'},
          {option: 'englandSurrey',                          label: 'England - Surrey'},
          {option: 'englandSwindon',                         label: 'England - Swindon'},
          {option: 'englandTorbay',                          label: 'England - Torbay'},
          {option: 'englandTyneAndWear',                     label: 'England - Tyne and Wear'},
          {option: 'englandWarrington',                      label: 'England - Warrington'},
          {option: 'englandWarwickshire',                    label: 'England - Warwickshire'},
          {option: 'englandWestBerkshire',                   label: 'England - West Berkshire'},
          {option: 'englandWestMidlands',                    label: 'England - West Midlands'},
          {option: 'englandWestSussex',                      label: 'England - West Sussex'},
          {option: 'englandWestYorkshire',                   label: 'England - West Yorkshire'},
          {option: 'englandWiltshire',                       label: 'England - Wiltshire'},
          {option: 'englandWindsorAndMaidenhead',            label: 'England - Windsor and Maidenhead'},
          {option: 'englandWokingham',                       label: 'England - Wokingham'},
          {option: 'englandWorcestershire',                  label: 'England - Worcestershire'},
          {option: 'englandYork',                            label: 'England - York'},
          {option: 'northernIrelandAntrim',                  label: 'Northern Ireland - Antrim'},
          {option: 'northernIrelandArds',                    label: 'Northern Ireland - Ards'},
          {option: 'northernIrelandArmagh',                  label: 'Northern Ireland - Armagh'},
          {option: 'northernIrelandBallymena',               label: 'Northern Ireland - Ballymena'},
          {option: 'northernIrelandBallymoney',              label: 'Northern Ireland - Ballymoney'},
          {option: 'northernIrelandBanbridge',               label: 'Northern Ireland - Banbridge'},
          {option: 'northernIrelandBelfast',                 label: 'Northern Ireland - Belfast'},
          {option: 'northernIrelandCarrickfergus',           label: 'Northern Ireland - Carrickfergus'},
          {option: 'northernIrelandCastlereagh',             label: 'Northern Ireland - Castlereagh'},
          {option: 'northernIrelandColeraine',               label: 'Northern Ireland - Coleraine'},
          {option: 'northernIrelandCookstown',               label: 'Northern Ireland - Cookstown'},
          {option: 'northernIrelandCraigavon',               label: 'Northern Ireland - Craigavon'},
          {option: 'northernIrelandDown',                    label: 'Northern Ireland - Down'},
          {option: 'northernIrelandDungannonAndSouthTyrone', label: 'Northern Ireland - Dungannon and South Tyrone'},
          {option: 'northernIrelandFermanagh',               label: 'Northern Ireland - Fermanagh'},
          {option: 'northernIrelandLarne',                   label: 'Northern Ireland - Larne'},
          {option: 'northernIrelandLimavady',                label: 'Northern Ireland - Limavady'},
          {option: 'northernIrelandLisburn',                 label: 'Northern Ireland - Lisburn'},
          {option: 'northernIrelandLondonderry',             label: 'Northern Ireland - Londonderry'},
          {option: 'northernIrelandMagherafelt',             label: 'Northern Ireland - Magherafelt'},
          {option: 'northernIrelandMoyle',                   label: 'Northern Ireland - Moyle'},
          {option: 'northernIrelandNewryAndMourne',          label: 'Northern Ireland - Newry and Mourne'},
          {option: 'northernIrelandNewtownabbey',            label: 'Northern Ireland - Newtownabbey'},
          {option: 'northernIrelandNorthDown',               label: 'Northern Ireland - North Down'},
          {option: 'northernIrelandOmagh',                   label: 'Northern Ireland - Omagh'},
          {option: 'northernIrelandStrabane',                label: 'Northern Ireland - Strabane'},
          {option: 'scotlandAberdeen',                       label: 'Scotland - Aberdeen'},
          {option: 'scotlandAberdeenshire',                  label: 'Scotland - Aberdeenshire'},
          {option: 'scotlandAngus',                          label: 'Scotland - Angus'},
          {option: 'scotlandArgyllAndBute',                  label: 'Scotland - Argyll and Bute'},
          {option: 'scotlandClackmannanshire',               label: 'Scotland - Clackmannanshire'},
          {option: 'scotlandDumfriesAndGalloway',            label: 'Scotland - Dumfries and Galloway'},
          {option: 'scotlandDundee',                         label: 'Scotland - Dundee'},
          {option: 'scotlandEastAyrshire',                   label: 'Scotland - East Ayrshire'},
          {option: 'scotlandEastDunbartonshire',             label: 'Scotland - East Dunbartonshire'},
          {option: 'scotlandEastLothian',                    label: 'Scotland - East Lothian'},
          {option: 'scotlandEastRenfrewshire',               label: 'Scotland - East Renfrewshire'},
          {option: 'scotlandEdinburgh',                      label: 'Scotland - Edinburgh'},
          {option: 'scotlandEileanSiar',                     label: 'Scotland - Eilean Siar'},
          {option: 'scotlandFalkirk',                        label: 'Scotland - Falkirk'},
          {option: 'scotlandFife',                           label: 'Scotland - Fife'},
          {option: 'scotlandGlasgow',                        label: 'Scotland - Glasgow'},
          {option: 'scotlandHighland',                       label: 'Scotland - Highland'},
          {option: 'scotlandInverclyde',                     label: 'Scotland - Inverclyde'},
          {option: 'scotlandMidlothian',                     label: 'Scotland - Midlothian'},
          {option: 'scotlandMoray',                          label: 'Scotland - Moray'},
          {option: 'scotlandNorthAyrshire',                  label: 'Scotland - North Ayrshire'},
          {option: 'scotlandNorthLanarkshire',               label: 'Scotland - North Lanarkshire'},
          {option: 'scotlandOrkneyIslands',                  label: 'Scotland - Orkney Islands'},
          {option: 'scotlandPerthAndKinross',                label: 'Scotland - Perth and Kinross'},
          {option: 'scotlandRenfrewshire',                   label: 'Scotland - Renfrewshire'},
          {option: 'scotlandScottishBorders',                label: 'Scotland - Scottish Borders'},
          {option: 'scotlandShetlandIslands',                label: 'Scotland - Shetland Islands'},
          {option: 'scotlandSouthAyrshire',                  label: 'Scotland - South Ayrshire'},
          {option: 'scotlandSouthLanarkshire',               label: 'Scotland - South Lanarkshire'},
          {option: 'scotlandStirling',                       label: 'Scotland - Stirling'},
          {option: 'scotlandWestDunbartonshire',             label: 'Scotland - West Dunbartonshire'},
          {option: 'scotlandWestLothian',                    label: 'Scotland - West Lothian'},
          {option: 'walesAnglesey',                          label: 'Wales - Anglesey'},
          {option: 'walesBlaenauGwent',                      label: 'Wales - Blaenau Gwent'},
          {option: 'walesBridgend',                          label: 'Wales - Bridgend'},
          {option: 'walesCaerphilly',                        label: 'Wales - Caerphilly'},
          {option: 'walesCardiff',                           label: 'Wales - Cardiff'},
          {option: 'walesCarmarthenshire',                   label: 'Wales - Carmarthenshire'},
          {option: 'walesCeredigion',                        label: 'Wales - Ceredigion'},
          {option: 'walesConwy',                             label: 'Wales - Conwy'},
          {option: 'walesDenbighshire',                      label: 'Wales - Denbighshire'},
          {option: 'walesFlintshire',                        label: 'Wales - Flintshire'},
          {option: 'walesGwynedd',                           label: 'Wales - Gwynedd'},
          {option: 'walesMerthyrTydfil',                     label: 'Wales - Merthyr Tydfil'},
          {option: 'walesMonmouthshire',                     label: 'Wales - Monmouthshire'},
          {option: 'walesNeathPortTalbot',                   label: 'Wales - Neath Port Talbot'},
          {option: 'walesNewport',                           label: 'Wales - Newport'},
          {option: 'walesPembrokeshire',                     label: 'Wales - Pembrokeshire'},
          {option: 'walesPowys',                             label: 'Wales - Powys'},
          {option: 'walesRhonddaCynonTaff',                  label: 'Wales - Rhondda Cynon Taff'},
          {option: 'walesSwansea',                           label: 'Wales - Swansea'},
          {option: 'walesTorfaen',                           label: 'Wales - Torfaen'},
          {option: 'walesValeOfGlamorgan',                   label: 'Wales - Vale of Glamorgan'},
          {option: 'walesWrexham',                           label: 'Wales - Wrexham'}
        ]
      };

      /**
       * Set the States Select options according to country
       * @param {str} countryCode
       * @return {bool} whether or not there are stateOptions for this country
       */
      function setStates(countryCode) {
        if( countryStates.hasOwnProperty(countryCode) ) {
          angular.copy(countryStates[countryCode],stateOptions);
          return true;
        }

        angular.copy([],stateOptions);
        return false;
      }

      var userFormOptions = {
        profile: {
          submit: 'Submit'
        },
        upgrade: {
          submit: 'Submit Upgrade'
        },
        signup: {
          submit: 'Join Now'
        }
        //full: not needed here as it gets converted to signup, but marks fullMember as checked
      };

      var userFields = [
        {
          key: 'type',
          type: 'readonly',
          templateOptions: {
            showOn: ['profile'],
            label: 'Member Type'
          }
        },
        {
          key: 'fullMember',
          type: 'radio',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: 'Why are you joining?',
            "options": [
              {
                "name": "Currently using The Vine Project in your church",
                "value": "current"
              },
              {
                "name": "Considering using The Vine Project in your church",
                "value": "considering"
              },
              {
                "name": "Other",
                "value": false
              }
            ]
          },
          expressionProperties: {
            'templateOptions.disabled': 'model.type==="full"'
          }
        },
        {
          key: 'div1',
          type: 'divider',
          templateOptions: {
            showOn: ['profile']
          }
        },
        {
          key: 'firstname',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'upgrade', 'profile'],
            type: 'text',
            label: 'First Name',
            placeholder: 'Enter your first name',
            required: true
            // focus: true
          }
        },
        {
          key: 'lastname',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'upgrade', 'profile'],
            type: 'text',
            label: 'Last Name',
            placeholder: 'Enter your last name',
            required: true
          }
        },
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile'],
            type: 'email',
            label: 'Email address',
            placeholder: 'Enter email',
            required: true
          }
        },
        {
          key: 'password',
          type: 'input',
          templateOptions: {
            showOn: ['signup'],
            type: 'password',
            label: 'Password',
            placeholder: 'Enter a password that is more than 8 characters long',
            required: true
          },
          validators:{
            minLength: '$viewValue.length >=8'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'password_confirmation',
          type: 'input',
          templateOptions: {
            showOn: ['signup'],
            type: 'password',
            label: 'Confirm Password'
          },
          hideExpression: "!model.password"
        },
        {
          key: 'newPassword',
          type: 'input',
          templateOptions: {
            showOn: ['profile'],
            type: 'password',
            label: 'Change Password',
            placeholder: 'If you would like to change your password, Enter a new password that is more than 8 characters long, otherwise, leave blank'
          }
        },
        {
          key: 'newPassword_confirmation',
          type: 'input',
          templateOptions: {
            showOn: ['profile'],
            type: 'password',
            label: 'Confirm Password'
          },
          hideExpression: "!model.newPassword"
          // validators:{
          //   confirmation: '$viewValue === model.newPassword'
          // }
        },
        {
          key: 'div2',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade']
          }
        },
        {
          key: 'intro',
          type: 'description',
          templateOptions: {
            showOn: ['upgrade'],
            label: '',
            text: 'If you are on the road to building a Vine Project team (or you’re already part of a team) then check the box below for Full Membership (free). You’ll receive access to the Team Manual as well as a host of resources to support you and your team through each phase of the project.  You’ll get access to FAQ’s, Podcasts, Real World Stories, how to deal with Common Roadblocks, Team Planning Documents, and more. You’ll also get access to a worldwide supportive community of ministry leaders who are committed to building a disciple-making culture.'
          }
        },
        {
          key: "timeframe",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'upgrade'],
            label: "Estimated timeframe for starting The Vine Project",
            valueProp: "option",
            labelProp: "label",
            options: timeframeOptions,
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "role",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Ministry Role",
            valueProp: "option",
            labelProp: "option",
            options: roleOptions,
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'organisationName',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Church/Organisation Name',
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'organisationUrl',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Organisation Website Address (URL)',
            placeholder: 'Please enter the main URL to help us identify your Church/Organisation'
          },
          hideExpression: "!model.fullMember",
          "expressionProperties": {
            "templateOptions.required": "model.fullMember === 'current' || model.fullMember === 'considering'"
          }
        },
        {
          key: "denomination",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Denomination",
            valueProp: "option",
            labelProp: "option",
            options: denominationOptions,
            required: false
          },
          hideExpression: "!model.fullMember || model.fullMember === 'considering'"
        },
        {
          key: 'address',
          type: 'input',
          templateOptions: {
            showOn: [],
            type: 'text',
            label: 'Address'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: "country",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "Country",
            valueProp: "option",
            labelProp: "label",
            options: countryOptions,
            required: true
          },
          hideExpression: "!model.fullMember",
          watcher: {
            listener: function(field, newValue) {
              vm.user.user.statesFieldHasOptions = setStates(newValue);
            }
          }
        },
        {
          key: "state",
          type: "select",
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: "State/County",
            valueProp: "option",
            labelProp: "label",
            options: stateOptions,
            required: true
          },
          hideExpression: "model.statesFieldHasOptions != true"
        },
        {
          key: 'state',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'State/County',
            required: false
          },
          hideExpression: "model.statesFieldHasOptions == true || !model.fullMember"
        },
        {
          key: 'suburb',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Suburb',
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'postcode',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Postcode / Zipcode',
            required: true
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'phone',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Phone'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'mobile',
          type: 'input',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            type: 'text',
            label: 'Mobile/Cell'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'div4',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade'],
            label: 'Subscription Options'
          }
        },
        {
          key: 'shareEmail',
          type: 'checkbox',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: 'Connecting team leaders'
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'shareNote',
          type: 'description',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: '',
            text: "I give permission for other Vine Project team leaders in my region or denomination to connect with me by email"
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'div5',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','profile','upgrade']
          },
          hideExpression: "!model.fullMember"
        },
        {
          key: 'subscribeGotherefor',
          type: 'checkbox',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: 'Subscribe to articles and ministry tips from Matthias Media'
          }
        },
        {
          key: 'subscribeNote',
          type: 'description',
          templateOptions: {
            showOn: ['signup', 'profile', 'upgrade'],
            label: '',
            text: "Matthias Media sends emails with resources, ideas and encouragement for fulfilling Christ’s commission to make disciples of all peoples. Of course you can unsubscribe at any time, but we anticipate it will be of great benefit to you."
          }
        },
        {
          key: 'div5',
          type: 'divider',
          templateOptions: {
            showOn: ['signup','upgrade'],
            label: 'What can we pray for you?'
          }
        },
        {
          key: 'notes',
          type: 'textarea',
          templateOptions: {
            showOn: ['signup', 'upgrade'],
            placeholder: "Notes for the staff including what we can be praying for you",
            rows: 4
          }
        }
      ];

      vm.onSignupSubmit = function() {
        var promise;
        usSpinnerService.spin('submit-spinner');
        clearMessage();

        if( vm.formType === 'profile' ) {
          if( vm.user.user.newPassword_confirmation !== vm.user.user.newPassword ) {
            showMessage("Please ensure your passwords match", 'error');
            return false;
          }
          promise = updateUser();
        } else if( vm.formType === 'upgrade' ) {
          promise = updateUser();
        } else {
          if( vm.user.user.password_confirmation !== vm.user.user.password ) {
            showMessage("Please ensure your passwords match", 'error');
            return false;
          }
          promise = createUser();
        }

        promise.then( function( response ) {
          if( ( ( response.response.data.meta || {} ).token) ) { //User was sucessfully created... go ahead and login
            showMessage('Your Profile has been updated','success');
            modalService.close();
            usSpinnerService.stop('submit-spinner');
            $state.go('home');
          } else if( response.response.data.upgradingAccount === true ) { //If the email existed already, but has now begun upgrade process
            showMessage("Your email address was already registered as a subscriber. We've sent you an email to complete the registration",'success');
          }
          usSpinnerService.stop('submit-spinner');
        }, function(response) {
          $log.error(response);
          var msg;
          if( response.response ) { //APFix - move error checking further up
            msg = response.response.data.message;
          } else {
            msg = response.data.message;
          }
          showMessage(msg,'error');
          usSpinnerService.stop('submit-spinner');
        });
      }

      function updateUser() {
        vm.user.user.use_method = 'PUT';
        $log.log(vm.user.user);
        return userService.save( vm.user.user );
      }

      function createUser() {
        return userService.registerNew( vm.user.user );
      }

      function showMessage(message, style) {
        vm.userClass = style==='error' ? 'alert-danger' : 'alert-success';
        vm.userMessage = message;

        $window.scrollTo(0,0);
      }

      function clearMessage() {
        vm.userMessage = '';
      }
      /**
       * Select Which Fields get passed through to the form based on the formType
       * @return {arr}
       */
      function chooseFields() {
        vm.userFormButton = userFormOptions[vm.formType].submit;

        return userFields.filter(function (el) {
          return (el.templateOptions.showOn.indexOf( vm.formType ) !== -1);
        });
      }

      init();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vineFooter', vineFooter);

  /** @ngInject */
  function vineFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      controller: FooterController,
      controllerAs: 'footerCtrl',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      var vm = this;

      vm.copyright = getCopyright();

      function getCopyright() {
        var yearStart = '2016';
        var year = new Date().getFullYear();

        return (year == yearStart) ? year : yearStart + ' - ' + year;
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('vinelib')
    .filter('shorten', shorten);

  /** @ngInject */
  function shorten() {

    return function (value, max, turnOff, tail) {
        if (!value) return '';

        if( turnOff )
          return value;

        var len = max ? max : 200;

        if( value.length < len )
          return value;
        
        tail = tail ? tail : '...';

        return value.substring(0,len)+tail;
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgComments', vgComments);

  /** @ngInject */
  function vgComments() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/comments/comments.html',
      scope: {
          comments: '=',
          resource: '='
      },
      controller: CommentsController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CommentsController(Comment, Resource, userService) {
      var vm = this;
      vm.newComment = {};
      vm.sendAnon = false;
      vm.currentUser = userService.currentUser;

      vm.submitComment = function() {
        vm.newComment.resource_id = vm.resource.id;
        Comment.post(vm.newComment)
          .then( function(data) {
            vm.comments = data;
            vm.resource.watching = true;
          });

        //reset
        vm.sendAnon = vm.newComment.anon;
        vm.newComment = { anon: vm.sendAnon };
        // $window.document.getElementById("vm.commentForm_input_comment_0").focus();
      };

      vm.deleteComment = function(comment) {
        comment = Comment.makeModel(comment);
        var index = vm.comments.indexOf(comment);

        comment.remove()
          .then( function() {
            vm.comments.splice( index, 1);
          });
      }

      vm.getWatchingText = function() {
        return vm.resource.watching ? 'Stop Watching' : 'Watch this resource';
      };

      vm.toggleWatch = function() {
        if( vm.resource.watching ) {
          Resource.unwatch( vm.resource.slug )
            .then( function() {
              vm.resource.watching = false;
            });
        } else {
          Resource.watch( vm.resource.slug )
            .then( function() {
              vm.resource.watching = true;
            });
        }
      };

      vm.commentFields = [
        {
          key: 'comment',
          type: 'textarea',
          templateOptions: {
            placeholder: 'Join in the discussion...',
            required: true,
            rows: 4
          }
        },
        {
          key: 'anon',
          type: 'checkbox',
          className: 'width-50',
          templateOptions: {
            label: 'Send Anonymously'
          }
        }
      ];
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .directive('vgCategoryGrid', vgCategoryGrid);

  /** @ngInject */
  function vgCategoryGrid() {
    var directive = {
      restrict: 'E',
      scope: {
          categorySlug: '@categorySlug',
          templateType: '@templateType'
      },
      template: '<ng-include src="vm.getTemplateUrl()"/>',
      controller: CategoryGridController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CategoryGridController($scope, categoryService, optionService) {
      var vm = this;
      vm.categoryList;
      vm.currentCategory;
      vm.parent = {empty: true};

      initialiseData();

      function initialiseData() {
        vm.categoryList = categoryService.menuCategories;
        vm.currentCategory = categoryService.currentCategory;
        vm.options = optionService.globalOptions;

        $scope.$watch('categorySlug', function(){
            categoryService.setCurrentCategoryBySlug( vm.categorySlug );
        }, true);
      }
      
      //Choose Template (list, grid)
      vm.getTemplateUrl = function() {
        if( vm.templateType === 'list' )
          return 'app/components/categoryGrid/categoryList.html';

        return 'app/components/categoryGrid/categoryGrid.html';
      }
    }
  }

})();

(function () {
  'use strict';

  //User Model
  angular
    .module('vinelib')
    .factory('User', User);

  User.$inject = ['Restangular', 'configService', '$http'];
  /** @ngInject */
  function User(Restangular, configService, $http) {
    //APFix: check here to see how to do the user model http://blog.revolunet.com/blog/2014/02/14/angularjs-services-inheritance/
    var urlPart = 'users';
    var _service = Restangular.all( urlPart );

    return {
      getAuthenticated: function() {
        return _service.get('current');
      },
      registerNew: function(data) {
        var url = configService.getLocalConfig( 'apiLocation' );
        return $http.post( url + '/' + urlPart,data,{});
      },
      sendPasswordEmail: function(data) {
        var url = configService.getLocalConfig( 'apiLocation' );
        return $http.post( url + '/auth/password/email' ,data,{});
      },
      resetPassword: function(data) {
        var url = configService.getLocalConfig( 'apiLocation' );
        return $http.post( url + '/auth/password/reset' ,data,{});
      },
      getNew: function() {
        return _service.one(urlPart);
      },
      save: function(data) {
        return _service.customPUT(data,data.id);
      }
    }
  }

  angular
    .module('vinelib')
    .service('userService', userService);

  userService.$inject = ['$q', '$state', '$log', '$http', 'configService', 'jwtHelper', 'User', 'Restangular'];
  /** @ngInject */
  function userService($q, $state, $log, $http, configService, jwtHelper, User, Restangular) {
    var self = this;
    var token = null;
    var observerCallbacks = [];
    self.currentUser = {
      loggedIn: false,
      user: {}
    };

    init();

    self.canAccess = canAccess;

    //register an observer so we get updated on the login state
    self.registerObserverCallback = function(callback){
      observerCallbacks.push(callback);
    }

    self.registerNew = function(data) {
      var deferred = $q.defer();
      User.registerNew(data)
        .then(function successCallback(response) {
          if( response.status !== 200 ) {
            deferred.reject({success: false, response: response});
          } else {
            if( ( ( response.data.meta || {} ).token) ) { //User was sucessfully created... go ahead and login
              setCurrentUser( response.data.meta.token, response.data.data );
              deferred.resolve({success: true, response: response});
            } else {
              deferred.resolve({success: true, response: response});
            }
          }
        }, function errorCallback(response) {
          deferred.reject({success: false, response: response});
        }
      );
      return deferred.promise;
    }

    self.sendPasswordEmail = function(data) {
      return User.sendPasswordEmail(data);
    }

    self.resetPassword = function(data) {
      return User.resetPassword(data);
    }

    self.save = function(data){
      var deferred = $q.defer();
      User.save(data)
        .then( function(data) {
          updateCurrentUser(data);
          deferred.resolve({success: true, response: {data: data} });
        });

      return deferred.promise;
    }

    self.login = function(data) {
      var deferred = $q.defer();
      Restangular.all('login').post(data)
        .then( function(response) {
          $log.log(response);
          if( response.hasOwnProperty('status') && response.status !==200 ) {
            clearCurrentUser();
            $log.error(response);
            deferred.reject({success: false, message: translateErrorMessage(response)});
          } else {
            setCurrentUser(response.token,response);
            deferred.resolve({success: true, message: 'Successfully logged in to the Library'});
          }
        }, function(response) {
          clearCurrentUser();
          $log.error(response);
          deferred.reject({success: false, message: translateErrorMessage(response)});
        }
      );
      return deferred.promise;
    }

    function init() {
      checkForLocalToken();
    }

    function canAccess(area) {
      var roleId = Number(self.currentUser.user.roleId);
      if( area === 'admin' ) {
        return ( roleId === 1 || roleId === 2 );
      }
    }

    function translateErrorMessage(response) {
      if( ! response.data.error )
        return null;

      var messages = {
        "invalid_credentials": "Email address or Password was incorrect"
      };

      return ( messages[ response.data.error ] ) ? messages[ response.data.error ] : '';

    }

    self.logout = function() {
      clearCurrentUser();
      $state.go('home');
    }

    self.getToken = function() {
      return token;
    }

    function setToken(newtoken) {
      if(newtoken===null || newtoken==='null' || newtoken==='undefined') {
        localStorage.removeItem("JWT");
      } else {
        localStorage.setItem('JWT', newtoken);
      }
      token = newtoken;
    }

    /**
     * Update any observers when the login state has changed
     */
    function notifyObservers(){
      angular.forEach(observerCallbacks, function(callback){
        callback();
      });
    }

    function clearCurrentUser() {
      setCurrentUser(null,{});
    }

    function setCurrentUser(token,data) {
      if( token === null || token === 'null') {
        self.currentUser.loggedIn = false;
      } else {
        self.currentUser.loggedIn = true;
      }
      setToken(token);
      Restangular.copy(data, self.currentUser.user);
      self.currentUser.isAdmin = canAccess('admin');
      notifyObservers();
    }

    function updateCurrentUser(data) {
      Restangular.copy(data, self.currentUser.user);
      self.currentUser.isAdmin = canAccess('admin');
      notifyObservers();
    }

    //grab the token from localStorage on startup
    function checkForLocalToken() {
      var _token = localStorage.getItem('JWT');
      if( _token === null || _token === 'null' || _token === 'undefined' ) {
        return false;
      }

      if( jwtHelper.isTokenExpired(_token) ) {
        return false;
      }

      User.getAuthenticated().then(function(data){
        setCurrentUser( _token, data );
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Resource', Resource);

  /** @ngInject */
  function Resource(Restangular) {
    var path = 'resources';

    var service = Restangular.service(path);

    service.watch = function( resourceSlug ) {
      return Restangular.one(path, resourceSlug).customOperation('post', 'watch');
    }

    service.unwatch = function( resourceSlug ) {
      return Restangular.one(path, resourceSlug).customOperation('post', 'unwatch');
    }

    service.edit = function( resourceSlug ) {
      return Restangular.one(path, resourceSlug).customOperation('get', 'edit');
    }
    
    service.getNew = function( ) {
      return Restangular.one(path).customOperation('get', 'getnew');
    }
    
    service.makeModel = function( data ) {
      return Restangular.restangularizeElement(null, data, path);
    }

    return service;

  }

  angular
    .module('vinelib')
    .service('resourceService', resourceService);

  /** @ngInject */
  function resourceService(Resource, Restangular) {
    var self = this;
    self.data = { featuredResources: [], searchResults: [], searchTerm: '', searching: false };

    self.search = function(searchTerm) {
      self.data.searchTerm = searchTerm;
      self.data.searching = true;

      var params = {
        search: self.data.searchTerm
      }

      self.data.searchResults.length = 0;

      return Resource.getList(params).then(function(data){
        self.data.searching = false;
        self.data.searchTerm = null;
        Restangular.copy(data, self.data.searchResults);
      });
    }

    function init() {
      // getFeatured();
      // userService.registerObserverCallback(getFeatured);
    }

    init();
  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Option', Option);

  // Option.$inject = ['Restangular'];

  /** @ngInject */
  function Option(Restangular) {
    
    var path = 'options';
    var _service = Restangular.all(path);

    _service.bulkUpdate = function( data ) {
      return Restangular.all( path )
        .customPOST( data, 'bulk', undefined);
    };

    // _service.updateResourceOrder = function( catId, data ) {
    //   return Restangular.all( path + '/' + catId )
    //     .customPOST( {order: data}, 'updateresourceorder', undefined);
    // };

    // _service.makeModel = function( data ) {
    //   return Restangular.restangularizeElement(null, data, path);
    // }

    return _service;
  }

  angular
    .module('vinelib')
    .service('optionService', optionService);

  /** @ngInject */
  function optionService(Option) {
    var self = this;
    self.globalOptions = {};

    init();

    // self.setCurrentOptionBySlug = function(slug) {
    //   currentSlug = slug;

    //   if( self.menuCategories.length > 0 ) {
    //     refreshCurrentOption();
    //   }
    // }

    // function refreshCurrentOption() {
    //   var currentOption = $filter('filter')(self.menuCategories, {slug: currentSlug}, true)[0];
    //   Restangular.copy(currentOption, self.currentOption);
    // }

    // function refreshCategories() {
    //   Option.getList({include: "children",toplevel: true, visibleonly: true}).then( function(data) {
    //     for (var i = 0; i < data.length; i++) {
    //       data[i].children = data[i].children.data; //promote the children.data property
    //     }
    //     Restangular.copy(data, self.menuCategories);
    //     if( currentSlug ) {
    //       refreshCurrentOption();
    //     }
    //   });
    // }

    //get & Cache Global Options
    function getGlobal() {
      var params = {
        // pagination: 6
      }

      Option.get('',params).then(function(data){
        var option;
        for (var i = data.length - 1; i >= 0; i--) {

          //Prepare Data
          if( data[i].key === 'displayResourceCount' ) {
            option = data[i].option === "1" ? true : false;
          } else {
            option = data[i].option;
          }

          self.globalOptions[ data[i].key ] = option;
        }
      });
    }

    function init() {
      getGlobal();
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Media', Media);

  /** @ngInject */
  function Media(Restangular) {
    var path = 'media';

    var service = Restangular.all(path);
    
    //Upload a file along with the model data
    //Not sure why I can't use this as a function on the model, but it didn't work. need to pass the model into the function - http://doblydev.blogspot.de/2014/06/angularjs-adding-new-objects-with.html
    service.uploadFile = function( model, file ) {
      var formData = new FormData();
      if( model.path === 'remote' ) {
        formData.append('filename', model.url);
      } else {
        formData.append('fileUpload', file );  
      }
      
      formData.append('title', model.title);
      formData.append('id', model.id);
      formData.append('path', model.path);
      formData.append('media_type', model.media_type);
      formData.append('resource_id', model.resource_id);

      if( model.id )
        formData.append('use_method', 'PUT');

      return Restangular.all( path )
        .withHttpConfig({transformRequest: angular.identity})
        .customPOST(formData, model.id, undefined, {'Content-Type': undefined});
    }

    return service;

  }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Comment', Comment);

  /** @ngInject */
  function Comment(Restangular) {
    var path = 'comments';
    var service = Restangular.service(path);

    service.makeModel = function( data ) {
      return Restangular.restangularizeElement(null, data, path);
    }

    return service;

  }

  // angular
  //   .module('vinelib')
  //   .service('commentService', commentService);

  /** @ngInject */
  // function commentService(Comment, Restangular) {
  //   var self = this;

  // }

})();

(function () {
  'use strict';

  angular
    .module('vinelib')
    .factory('Category', Category);

  // Category.$inject = ['Restangular'];

  /** @ngInject */
  function Category(Restangular) {
    
    var path = 'categories';
    var _service = Restangular.all(path);

    _service.updateOrder = function( data ) {
      return Restangular.all( path )
        .customPOST( {order: data}, 'updateorder', undefined);
    };

    _service.updateResourceOrder = function( catId, data ) {
      return Restangular.all( path + '/' + catId )
        .customPOST( {order: data}, 'updateresourceorder', undefined);
    };

    _service.makeModel = function( data ) {
      return Restangular.restangularizeElement(null, data, path);
    }

    // _service.getChildren = function(categorySlug) {
    //   return Restangular.all( 'categories/' + categorySlug + '/categories', {include: 'children'}).getList().$object;
    // };

    // _service.getToplevel = function() {
    //   return _service.getList({toplevel: true}).$object;
    // };

    return _service;
  }

  angular
    .module('vinelib')
    .service('categoryService', categoryService);

  /** @ngInject */
  function categoryService(Category, Restangular, $filter, userService, $timeout) {
    var self = this;
    self.menuCategories = [];
    self.currentCategory = [];
    self.featuredResources = [];
    self.availableTypes = { //Key is 10 character max string
      plandoc: {
        'type': 'plandoc',
        'name': 'Planning Doc',
        'text': 'Download'
      },
      template: {
        'type': 'template',
        'name': 'TVP Template',
        'text': 'Download'
      },
      article: {
        'type': 'article',
        'name': 'Article',
        'text': 'Read'
      },
      audio: {
        'type': 'audio',
        'name': 'Audio',
        'text': 'Listen'
      },
      video: {
        'type': 'video',
        'name': 'Video',
        'text': 'Watch'
      },
      diagram: {
        'type': 'diagram',
        'name': 'Diagram',
        'text': 'Download'
      },
      survey: {
        'type': 'survey',
        'name': 'Survey',
        'text': 'Download'
      }
    };

    var currentSlug = null;

    init();

    self.setCurrentCategoryBySlug = function(slug) {
      currentSlug = slug;

      if( self.menuCategories.length > 0 ) {
        refreshCurrentCategory();
      }
    }

    self.searchBySlug = function(slug) {

      var found = false;
      
      angular.forEach( self.menuCategories, function(pValue) {
        if( found === false ) {
          if( slug === pValue.slug ) {
            found = pValue;
          } else {
            angular.forEach( pValue.children, function(cValue) {
              if( slug === cValue.slug ) {
                found = cValue;
                found.parent = pValue;
              }
            });
          }
        }
      });

      return found;
    }

    function refreshCurrentCategory() {
      var currentCategory = $filter('filter')(self.menuCategories, {slug: currentSlug}, true)[0];
      Restangular.copy(currentCategory, self.currentCategory);
    }

    function refreshCategories() {
      Category.getList({include: "children",toplevel: true, visibleonly: true}).then( function(data) {
        for (var i = 0; i < data.length; i++) {
          data[i].children = data[i].children.data; //promote the children.data property
        }
        Restangular.copy(data, self.menuCategories);
        if( currentSlug ) {
          refreshCurrentCategory();
        }
      });
    }

    //get Featured Articles and cache them
    function getFeatured() {
      var params = {
        include: 'resources'
        // pagination: 6
      }

      Category.get('featured',params).then(function(data){
        Restangular.copy(data.resources.data, self.featuredResources);
      });
    }

    function init() {
      if( self.menuCategories.length === 0 ) {
        refreshCategories();
      }
      if( userService.currentUser.loggedIn === false ) {
        getFeatured();
      }
      $timeout(function() { //Avoid double loading of featured resources if already logged in
        userService.registerObserverCallback(getFeatured);
      }, 5000);
    }

  }

})();
// (function() {
//   'use strict';

//   angular
//     .module('vinelib')
//     .controller('MainController', MainController);

//   /** @ngInject */
//   function MainController($stateParams, Resource) {
//     var vm = this;

//     vm.categorySlug = $stateParams.categorySlug ? $stateParams.categorySlug : 'phaseresources';

//     loadResources();

//     function loadResources() {
//       //Setup query parameters
//       var params = {
//         filter: 'featured',
//         pagination: 5
//       }

//       //Get data via model
//       Resource.getList(params).then(function(data){
//         vm.resources = data;
//       });        
//     }

//   }
// })();

(function() {
  'use strict';

  angular
    .module('vinelib')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, userService, configService, Restangular, usSpinnerService, $log) {

    registerEventHandler();

    /**
     * Register event handler for ui-router state change
     * See https://github.com/angular-ui/ui-router/wiki for more information.
     */
    function registerEventHandler() {

      var unlisten = $rootScope.$on('$stateChangeStart', function (event, toState) {
        //Don't bother checking for Admin Access (debugging use only)
        if( ! configService.getLocalConfig( 'checkFence' ) )
          return true;

        if(toState.name && toState.name.match(/^admin\./)){
          if( ! userService.canAccess('admin') ) {
            $log.debug('Access not allowed. Redirecting to home page');
            event.preventDefault();
            return $state.go('home');
          }
        }
      });

      $rootScope.$on('$destroy', unlisten);

      //Start loading spinner on request
      Restangular.addRequestInterceptor(function(element) {
          usSpinnerService.spin('main-spinner');
          return element;
      });

      //Stop loading spinner after request
      Restangular.addResponseInterceptor(function(element) {
          usSpinnerService.stop('main-spinner');
          return element;
      });


      //Set Default Error Handlers
      Restangular.setErrorInterceptor(function(response) {
        if(response.status === 403) {
        //   resourceService.getFeatured(); APFix: Make Provider so we can refresh featured items from here
          $state.go('home');
          return false;
        }

        return true; // error not handled
      });
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('vinelib')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('home', {
      url: '/:categorySlug',
      templateUrl: 'app/pages/home/home.html',
      controller: 'HomeController',
      controllerAs: 'home',
      tvpCrumb: {
        level: 0,
        label: ":categorySlug"
      }
    });

    $stateProvider.state('category', {
      url: '/categories/:categorySlug',
      templateUrl: 'app/pages/category/category.html',
      controller: 'CategoryController',
      controllerAs: 'category',
      tvpCrumb: {
        level: 1,
        label: ':categorySlug'
      }
    });

    $stateProvider.state('resource', {
      url: '/resources/:resourceSlug',
      templateUrl: 'app/pages/resource/resource.html',
      controller: 'ResourceController',
      controllerAs: 'resource',
      resolve: {
        resourceModel: function($stateParams, Resource) {
          return Resource.one( $stateParams.resourceSlug ).get();
        }
      },
      tvpCrumb: {
        level: 2,
        label: ':resourceSlug'
      }
    });

    // Administration area
    $stateProvider.state('admin', {
      abstract: true,
      template: "<ui-view/>"
    });

    $stateProvider.state('admin.resources', {
      url: '/admin/resources',
      templateUrl: 'app/pages/adminresources/adminresources.html',
      controller: 'AdminresourcesController',
      controllerAs: 'adminresourcesCtrl',
      tvpCrumb: {
        level: 1,
        label: ' Edit Resources',
        link: 'admin.resources',
        parent: {
          name: 'Admin',
          link: "home"
        }
      }
    });

    $stateProvider.state('admin.editresource', {
      url: '/resources/:resourceSlug/edit',
      templateUrl: 'app/pages/editresource/editresource.html',
      controller: 'EditresourceController',
      controllerAs: 'editresourceCtrl',
      resolve: {
        resource: function($stateParams, Resource) {
          return Resource.edit( $stateParams.resourceSlug );
        }
      },
      tvpCrumb: {
        level: 2,
        label: ':resourceSlug'
      }
    });

    $stateProvider.state('admin.config', {
      url: '/admin/config',
      templateUrl: 'app/pages/config/config.html',
      controller: 'ConfigController',
      controllerAs: 'configCtrl',
      tvpCrumb: {
        level: 1,
        label: 'Configuration',
        parent: {
          name: 'Admin',
          link: "home"
        }
      }
    });

    $stateProvider.state('admin.editcategory', {
      url: '/admin/categories',
      templateUrl: 'app/pages/editcategory/editcategory.html',
      controller: 'EditcategoryController',
      controllerAs: 'editcategoryCtrl',
      tvpCrumb: {
        level: 1,
        label: 'Edit Categories',
        link: 'admin.editcategory',
        parent: {
          name: 'Admin',
          link: "home"
        }
      }
    });

    $stateProvider.state('admin.newresource', {
      url: '/admin/newresource',
      templateUrl: 'app/pages/editresource/editresource.html',
      controller: 'EditresourceController',
      controllerAs: 'editresourceCtrl',
      resolve: {
        resource: function($stateParams, Resource) {
          return Resource.edit( 'new' );
        }
      }
    });

    $stateProvider.state('admin.media', {
      url: '/admin/media',
      templateUrl: 'app/pages/media/media.html',
      controller: 'MediaController',
      controllerAs: 'mediaCtrl',
      tvpCrumb: {
        level: 1,
        label: 'Edit Media',
        parent: {
          name: 'Admin',
          link: "home"
        }
      }
    });

    $stateProvider.state('admin.changelog', {
      url: '/admin/changelog',
      templateUrl: 'app/pages/changelog/changelog.html',
      controller: 'ChangelogController',
      controllerAs: 'changelogCtrl',
      tvpCrumb: {
        level: 1,
        label: 'Software Changelog',
        parent: {
          name: 'Admin',
          link: "home"
        }
      }
    });

    $stateProvider.state('profile', {
      url: '/settings/profile',
      templateUrl: 'app/pages/profile/profile.html',
      controller: 'ProfileController',
      controllerAs: 'profileCtrl',
      params: {formtype: 'profile'},
      tvpCrumb: {
        level: 1,
        label: 'profile',
        parent: {
          name: 'Home',
          link: "home"
        }
      }
    });

    $stateProvider.state('join', {
      abstract: true,
      template: "<ui-view/>",
      tvpCrumb: {
        level: 1,
        label: 'join',
        parent: {
          name: 'Home',
          link: "home"
        }
      }
    });

    $stateProvider.state('join.info', {
      url: '/join/info',
      templateUrl: 'app/pages/membership/membership.html',
      controller: 'MembershipController',
      controllerAs: 'membershipCtrl',
      params: {page: 'info'}
    });

    $stateProvider.state('join.lite', {
      url: '/join/lite',
      templateUrl: 'app/pages/membership/membership.html',
      controller: 'MembershipController',
      controllerAs: 'membershipCtrl',
      params: {formtype: 'signup', page: 'form'}
    });

    $stateProvider.state('join.full', {
      url: '/join/full',
      templateUrl: 'app/pages/membership/membership.html',
      controller: 'MembershipController',
      controllerAs: 'membershipCtrl',
      params: {formtype: 'full', page: 'form'}
    });

    $stateProvider.state('search', {
      url: '/library/search',
      templateUrl: 'app/pages/search/search.html',
      controller: 'SearchController',
      controllerAs: 'searchCtrl',
      params: {searchTerm: null},
      tvpCrumb: {
        level: 1,
        label: 'Search'
      }
    });

    $stateProvider.state('password-reset', {
      url: '/password/reset',
      templateUrl: 'app/pages/password/reset.html',
      controller: 'PasswordController',
      controllerAs: 'passCtrl'
    });

    $stateProvider.state('password-change', {
      url: '/password/change/:email/:token',
      templateUrl: 'app/pages/password/change.html',
      controller: 'PasswordController',
      controllerAs: 'passCtrl'
    });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('vinelib')
    .constant('moment', moment);

})();

/* globals $, localConfig */

(function() {
  'use strict';

    angular
    .module('vinelib')
    .service('configService', configService);

  /** @ngInject */
  function configService() {
    var alreadyRetrievedLocal = false;
    var vineConfig = {
      "debug": false,
      "appName": "The Vine Project API",
      "apiLocation": "http://api.thevineproject.com",
      "checkFence": true //used for debugging - doesn't redirect if the user doesn't have admin access
    };

    this.getLocalConfig = function (key) {
      if( ! alreadyRetrievedLocal ) {
        if (typeof localConfig !== 'undefined')
          vineConfig = $.extend( vineConfig, localConfig );

        alreadyRetrievedLocal = true;
      }

      if( typeof vineConfig[key] === 'undefined' )
        return false;

      return vineConfig[key];
    };

  }

  angular
    .module('vinelib')
    .config(config);

  /** @ngInject */
  function config($logProvider, RestangularProvider, $httpProvider, jwtInterceptorProvider, configServiceProvider, $compileProvider) {
    // Enable log
    $logProvider.debugEnabled(false);

    // Disable AngularJS from attaching information about binding and scopes to DOM nodes
    // Can still debug by typing 'angular.reloadWithDebugInfo();' into the console
    $compileProvider.debugInfoEnabled(false);

    //Disable comment and css class directives for performance, since we're not using them
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);
    
    //Get Config Service
    var _config = configServiceProvider.$get();

    //###Setup Restangular
    //Set the Base URL
    RestangularProvider.setBaseUrl( _config.getLocalConfig( 'apiLocation' ) );
    
    //Modify the response
    RestangularProvider.addResponseInterceptor(function(data) {
      var extractedData;
      
      if( data.hasOwnProperty("data") ) {
        extractedData = data.data;
      } else {
        extractedData = data;
      }

      if( data.hasOwnProperty("meta") ) {
        angular.extend( extractedData, data.meta );
      }

      return extractedData;
    });

    // Send Token through on each API request
    jwtInterceptorProvider.tokenGetter = function() {
      return localStorage.getItem('JWT');
    };

    $httpProvider.interceptors.push('jwtInterceptor');

    //Disable the spinner from the loading bar (it clashes with the logo)
    // cfpLoadingBarProvider.includeSpinner = false;

  }

})();
angular.module("vinelib").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/categoryGrid/categoryList.html","<div class=row><h2>{{ vm.currentCategory.name }}</h2><div class=\"category-item row col-xs-12\" ng-repeat=\"category in vm.currentCategory.children\"><a ui-sref=\"category({ categorySlug: category.slug })\" class=category-item-inner><h4>{{ category.name }}&nbsp;<small ng-if=vm.options.displayResourceCount>({{ category.resources_count }})</small></h4><span><i class=\"fa fa-chevron-right\" aria-hidden=true></i></span></a></div></div>");
$templateCache.put("app/components/comments/comments.html","<div class=comments-wrap ng-if=vm.currentUser.loggedIn><h4>Discussion about this article <a class=\"watch-button btn btn-small btn-default pull-right\" ng-click=vm.toggleWatch()>{{ vm.getWatchingText() }}</a></h4><form class=comment-form ng-submit=vm.submitComment() name=vm.commentForm novalidate><formly-form model=vm.newComment fields=vm.commentFields form=vm.commentForm><div class=\"text-right pull-up\"><button type=submit class=\"btn btn-primary\" ng-disabled=vm.commentForm.$invalid>Send</button></div></formly-form></form><hr><div class=comment-item ng-repeat=\"comment in vm.comments\" ng-class=\"{own : comment.currentAuthor}\"><div class=bubble ng-click=\"comment.showAll=!comment.showAll\">{{ comment.comment | shorten : 200 : comment.showAll }}</div><div class=meta>{{ comment.author }}, {{ comment.published }}&nbsp;<i ng-show=vm.currentUser.isAdmin ng-click=vm.deleteComment(comment) class=\"fa fa-trash\" aria-hidden=true></i></div></div><div ng-show=!vm.comments.length>No comments have been made on this article yet</div></div><div class=comments-wrap ng-if=!vm.currentUser.loggedIn><h4>Discussion about this article</h4><p>Adding and Viewing Comments is only available to logged in members</p></div>");
$templateCache.put("app/components/footer/footer.html","<footer><div class=\"bg-col-dark inverse row footer-top\"><div class=container><div class=pull><ul><!-- <li><a href=\"https://vinegrowers.com/\">Vinegrowers</a></li> --><li><a href=https://thevineproject.com/ >The Vine Project</a></li><li><a href=https://thevineproject.com/privacy/ >Privacy</a></li><li><a href=https://thevineproject.com/donate/ >Donate</a></li><li><a href=https://thevineproject.com/contact/ >Contact</a></li></ul></div></div></div><div class=\"bg-col-dark inverse row footer-bottom\"><div class=container><div class=pull><p>&copy; {{footerCtrl.copyright}} <a href=https://vinegrowers.com/ >Vinegrowers Ltd.</a> | Developed by <a target=_blank href=http://cubesystems.com.au>Cube Systems</a> | Design by <a target=_blank href=http://elevatecreative.com.au>Elevate Creative</a>. | v1.1.8</p></div></div></div></footer>");
$templateCache.put("app/components/formSignup/formSignup.html","<div class=text-center ng-hide=vm.user.loggedIn><a class=small ng-click=vm.openLogin()>Already Registered? Login</a><br>&nbsp;<br></div><div id=modalMessage ng-show=vm.userMessage class=alert ng-class=vm.userClass>{{ vm.userMessage }}</div><form class=join-form ng-submit=vm.onSignupSubmit() name=vm.signupForm novalidate><formly-form model=vm.user.user fields=vm.userFields form=vm.signupForm><div class=text-right style=position:relative><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=vm.signupForm.$invalid>{{vm.userFormButton}}</button> <span us-spinner=\"{radius:5, length:10, width:5, left:\'70%\'}\" spinner-key=submit-spinner></span></div></formly-form></form>");
$templateCache.put("app/components/forms/description.html","<div class=form-group><div>{{options.templateOptions.text}}</div></div>");
$templateCache.put("app/components/forms/divider.html","<h4 ng-if=to.label>{{options.templateOptions.label}}</h4><hr>");
$templateCache.put("app/components/forms/editor.html","<div class=form-group><div><text-angular ng-model=model[options.key]></text-angular></div></div>");
$templateCache.put("app/components/forms/readonly.html","<label class=control-label ng-if=to.label>{{options.templateOptions.label}}:&nbsp;</label>{{model[options.key]}}");
$templateCache.put("app/components/modal/modal.html","<div class=modal-header><h3>{{modalOptions.headerText}}</h3></div><div class=modal-body><p>{{modalOptions.bodyText}}</p><div id=tpl-content ng-include src=modalOptions.bodyTemplate></div></div><div class=modal-footer ng-show=modalOptions.actionButtonText><button type=button class=btn data-ng-click=modalOptions.close()>{{modalOptions.closeButtonText}}</button> <button class=\"btn btn-primary\" data-ng-click=\"modalOptions.ok( modalOptions.user );\">{{modalOptions.actionButtonText}}</button></div>");
$templateCache.put("app/components/navbar/menu.html","<div class=alt-menu-container><div class=\"hidden-md hidden-lg\"><a class=\"btn btn-navbar pull-right\" ng-click=vm.closeMenu()><span class=\"fa fa-bars\"></span></a><h4>The Vine Project</h4><a ui-sref=\"resource({resourceSlug: \'team-manual\'})\" class=\"btn btn-info btn-fullsize\" ng-show=vm.user.user.fullMember ng-click=vm.closeMenu()><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Download Team Manual</a><ul class=alt-menu><li ng-click=\"vm.toggleMenuItem(\'user\')\">User <i class=\"fa fa-plus\" aria-hidden=true></i><ul uib-collapse=\"vm.currentMenuOpen !== \'user\'\"><li ng-hide=vm.user.loggedIn><a ng-click=vm.openLogin()>Login</a></li><li ng-show=vm.user.loggedIn><a ng-click=vm.closeMenu() ui-sref=profile )>Profile</a></li><li ng-show=vm.user.loggedIn><a ng-click=vm.logoutUser() )>Logout {{vm.user.user.firstname}}</a></li></ul></li><li ng-show=vm.user.isAdmin ng-click=\"vm.toggleMenuItem(\'admin\')\">Admin <i class=\"fa fa-plus\" aria-hidden=true></i><ul uib-collapse=\"vm.currentMenuOpen !== \'admin\'\"><li><a ng-click=vm.closeMenu() ui-sref=admin.media )>Media</a></li><li><a ng-click=vm.closeMenu() ui-sref=admin.editcategory )>Categories</a></li><li><a ng-click=vm.closeMenu() ui-sref=admin.resources )>Resources</a></li><li><a ng-click=vm.closeMenu() ui-sref=admin.config )>Configuration</a></li></ul></li><li ng-click=\"vm.toggleMenuItem(\'search\')\">Search <i class=\"fa fa-plus\" aria-hidden=true></i></li><li uib-collapse=\"vm.currentMenuOpen !== \'search\'\"><form class=search-box ng-submit=vm.performSearch() name=vm.loginForm novalidate><input class=form-control ng-model=vm.searchTerm name=searchTerm placeholder=Search type=text aria-invalid=false></form></li></ul></div><h4>Resources</h4><ul class=alt-menu><li ng-repeat=\"category in vm.categories\" ng-click=vm.toggleMenuItem(category.slug) class=alt-menu-category>{{ category.name }} <i class=\"fa fa-plus\" aria-hidden=true></i><ul uib-collapse=\"vm.currentMenuOpen !== category.slug\"><li ng-repeat=\"child in category.children\"><a ui-sref=\"category({ categorySlug: child.slug })\" ng-click=vm.closeMenu()>{{ child.name }}</a></li></ul></li></ul><h4>Community</h4><ul class=alt-menu><!-- <li><a href=\"#\">My Comments</a></li> --><li><a href=https://www.facebook.com/groups/thevineproject/ target=_blank ng-click=vm.closeMenu()>Members Facebook</a></li><li><a href=https://www.facebook.com/thevineproject.org/ target=_blank ng-click=vm.closeMenu()>TVP Facebook Page</a></li><li><a href=https://thevineproject.com/contact/ target=_blank ng-click=vm.closeMenu()>Contact TVP Team</a></li></ul><h4>About</h4><ul class=alt-menu><li><a href=https://thevineproject.com/ target=_blank ng-click=vm.closeMenu()>The Vine Project</a></li><li><a href=http://www.vinegrowers.com/ target=_blank ng-click=vm.closeMenu()>Vinegrowers</a></li><li><a href=https://thevineproject.com/donate/ target=_blank ng-click=vm.closeMenu()>Donate</a></li><li><a href=https://thevineproject.com/privacy/ target=_blank ng-click=vm.closeMenu()>Privacy</a></li></ul></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar row navbar-fixed-top\"><div class=topbar><div class=topbar-links><ul class=global-sitelinks><li><a href=https://vinegrowers.com/ title=Vinegrowers>Vinegrowers</a></li><li><a href=https://thevineproject.com/ title=\"The Vine Project\">The Vine Project</a></li><li class=active><a href=# title=\"Resource Library\">Resource Library</a></li></ul></div></div><div class=\"navbar-inner bg\"><div class=container-fluid><a class=\"btn btn-navbar\" ng-click=\"vm.openMenu(\'top\',true)\"><span class=\"fa fa-bars\"></span> </a><a ui-sref=home() class=\"navbar-brand brand-logo\"><img src=assets/images/vine-logo.png> </a><a ui-sref=home() class=\"navbar-brand brand-title\">Resource Library</a><div class=nav-collapse><ul class=\"nav navbar-nav pull-right\" id=navbar-links><li class=nav-item ui-sref-active=active><a ui-sref=\"home({categorySlug: \'phaseresources\'})\">Phase Resources</a></li><li class=nav-item ui-sref-active=active><a ui-sref=\"home({categorySlug: \'general\'})\">General Resources</a></li><li class=nav-item><a class=\"btn btn-inverse\" ng-click=vm.openLogin() ng-hide=vm.user.loggedIn><i class=\"fa fa-user\" aria-hidden=true></i> Login</a></li><li class=nav-item uib-dropdown on-toggle=toggled(open)><a href id=user-dropdown ng-show=vm.user.loggedIn uib-dropdown-toggle><i class=\"fa fa-user\" aria-hidden=true></i></a><ul class=dropdown-menu uib-dropdown-menu><li><a ui-sref=profile ng-show=vm.user.loggedIn )>Profile</a></li><li><a ng-click=vm.logoutUser() ng-show=vm.user.loggedIn )>Logout {{vm.user.user.firstname}}</a></li></ul></li><li class=nav-item uib-dropdown on-toggle=toggled(open) ng-show=vm.user.isAdmin><a href id=settings-dropdown uib-dropdown-toggle><i class=\"fa fa-cogs\" aria-hidden=true></i></a><ul class=dropdown-menu uib-dropdown-menu><li><a ui-sref=admin.media )>Media</a></li><li><a ui-sref=admin.editcategory )>Categories</a></li><li><a ui-sref=admin.resources )>Resources</a></li><li><a ui-sref=admin.config )>Configuration</a></li><li><a ui-sref=admin.changelog )>Software Changelog</a></li></ul></li><li ng-if=vm.searchOpen class=nav-item><form class=search-box ng-submit=vm.performSearch() name=vm.loginForm novalidate><input class=form-control ng-model=vm.searchTerm name=searchTerm placeholder=\"Search and hit enter\" type=text aria-invalid=false> <button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=!vm.searchTerm>Go</button></form></li><li ng-if=!vm.searchOpen class=nav-item><a ng-click=\"vm.searchOpen= !vm.searchOpen\"><i class=\"fa fa-search\" aria-hidden=true></i></a></li><li class=nav-item><a ng-click=\"vm.openMenu(\'right\',true)\"><i class=\"fa fa-bars\" aria-hidden=true></i></a></li></ul></div></div></div></nav><div class=breadcrumb-wrapper ng-if=\"vm.breadCrumbReindexed.length > 1\"><ul class=breadcrumb><li ng-repeat=\"crumb in vm.breadCrumbReindexed\"><a ng-if=crumb.link href={{crumb.link}}>{{ crumb.name }}</a> <span ng-if=\"crumb.link === null\">{{ crumb.name }}</span></li></ul></div><script type=text/ng-template id=/loginTemplate.html><div class=\"text-center\" ng-hide=\"vm.user.loggedIn\">\n    <a class=\"small\" ui-sref=\"join.info\">Not Yet Registered? Sign Up</a><br>&nbsp;<br>\n  </div>\n  <form ng-submit=\"vm.submitLoginForm()\" name=\"vm.loginForm\" novalidate>\n    <div ng-show=\"vm.loginMessage\" class=\"alert\" ng-class=\"vm.loginClass\">{{ vm.loginMessage }}</div>\n    <formly-form model=\"vm.loginData\" fields=\"vm.loginFields\" form=\"vm.loginForm\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <a class=\"small\" ui-sref=\"password-reset()\">Forgot Password?</a>\n        </div>\n        <div class=\"col-sm-6 text-right\">\n          <button type=\"submit\" class=\"btn btn-lg btn-primary\" ng-disabled=\"vm.loginForm.$invalid\">Login</button>\n        </div>\n      </div>\n    </formly-form>\n  </form></script><script type=text/ng-template id=/formSignup.html><vg-form-signup form-type=\"signup\"></vg-form-signup></script><script type=text/ng-template id=/formFull.html><vg-form-signup form-type=\"full\"></vg-form-signup></script><script type=text/ng-template id=/formUpgrade.html><vg-form-signup form-type=\"upgrade\"></vg-form-signup></script>");
$templateCache.put("app/components/sidebar/sidebar.html","<div class=\"col-sm-12 well\"><h2>Related</h2></div>");
$templateCache.put("app/components/resourceGrid/resourceGrid.html","<div class=filter-box ng-if=vm.showFilter><span>FILTER BY:&nbsp;</span><div class=btn-group><button class=btn ng-if=\"vm.fltr.filtered > 0\" ng-click=\"vm.filter(\'category\',\'clear\')\">Show All</button> <button ng-repeat=\"filter in vm.fltr.buttons\" class=\"btn btn-info\" ng-class=\"{\'btn-warning\': vm.filterData.category==filter.slug}\" ng-click=\"vm.filter(\'category\',filter.slug)\">{{ filter.name }}</button></div><div class=btn-group uib-dropdown is-open=status.isopen><button id=single-button type=button class=btn uib-dropdown-toggle ng-disabled=disabled>Resource Type <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li ng-repeat=\"(type, value) in vm.fltr.types\" role=menuitem ng-click=\"vm.filter(\'type\',type,value)\" ng-class=\"{\'disabled\': !value.state, \'selected\': value.selected}\"><i class=\"fa fa-check\" aria-hidden=true ng-if=value.selected></i>{{ value.name }}</li></ul></div></div><div><div class=\"animate-repeat resource-item col-sm-4\" ng-repeat=\"resource in vm.resources | filter : vm.filterBar\"><a ng-click=vm.resourceAction($event,resource) ui-sref=\"resource({ resourceSlug: resource.slug })\" class=\"resource-inner vg-grid-item col-sm-12\"><div class=\"resource-img img-crop-narrow\"><img ng-src=\"{{ resource.feature }}\" alt=\"{{ resource.title }}\"></div><div class=details><div class=caption><h4>{{ resource.title }}</h4></div><span class=meta>{{ resource.author_name }} | {{ resource.published }} | {{ vm.capitalise( vm.availableTypes[ resource.type ].name ) }}</span><div class=action-button><span class=btn ng-class=vm.buttonClass(resource)>{{ vm.getButtonText( resource ) }}</span></div></div></a></div></div>");
$templateCache.put("app/pages/adminresources/adminresources.html","<div class=\"admin-resources maincol col-md-12\"><h2>Resources <a class=\"btn btn-lg btn-default\" ui-sref=\"admin.editresource({resourceSlug: \'new\'})\">Add New Resource</a></h2><ul class=resource-list><li ng-repeat=\"resource in adminresourcesCtrl.resources\"><a ui-sref=\"admin.editresource({resourceSlug: resource.slug})\">{{ resource.title }} <small>({{resource.status}})</small></a></li></ul><div class=clearfix></div><ul uib-pagination items-per-page=adminresourcesCtrl.resources.pagination.per_page total-items=adminresourcesCtrl.resources.pagination.total ng-model=adminresourcesCtrl.pagination ng-change=adminresourcesCtrl.pageChanged()></ul></div>");
$templateCache.put("app/pages/category/category.html","<div class=\"maincol col-xs-12 col-lg-12\"><div class=page-summary><h2>{{ category.category.name }}</h2><p>{{ category.category.desc }}</p></div><h3>Resources</h3><vg-resource-grid resources=category.resources show-filter=true template-type=grid>Loading...</vg-resource-grid></div><!-- <vg-sidebar></vg-sidebar> -->");
$templateCache.put("app/pages/changelog/changelog.html","<div class=\"maincol col-md-12\"><h2>The Vine Project Library Software Changelog</h2><div class=changelog><div class=well ng-repeat=\"version in changelogCtrl.versions\"><h4>Version {{ version.versionnumber }} - <small>{{ version.date }}</small></h4><hr><table class=table><thead><tr><th>Job</th><th>Type</th><th>Title</th><th>C</th><th>A</th><th>Description</th></tr></thead><tbody><tr ng-repeat=\"change in version.changes\"><td nowrap><a ng-show=change.link href=\"{{ change.link }}\">{{ change.job }}</a><span ng-hide=change.link>{{ change.job }}</span></td><td nowrap>{{ change.type }}</td><td nowrap>{{ change.title }}</td><td><span ng-show=\"change.in.search(\'C\') >= 0\">X</span></td><td><span ng-show=\"change.in.search(\'A\') >= 0\">X</span></td><td><small>{{ change.desc }}<ul><li ng-repeat=\"task in change.tasks\">{{ task }}</li></ul></small></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/config/config.html","<div class=\"maincol col-md-12\"><h2>The Vine Project Library Configuration Page</h2><form class=config-form ng-submit=configCtrl.onEditSubmit() name=configCtrl.configForm novalidate><div class=col-md-8><formly-form model=configCtrl.options fields=configCtrl.formFields form=configCtrl.configForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=configCtrl.configForm.$invalid>Save</button></div></formly-form></div></form></div>");
$templateCache.put("app/pages/editcategory/editcategory.html","<div class=\"maincol col-md-6\"><h2>Edit Categories &nbsp; <small><button class=\"btn btn-primary\" ng-click=editcategoryCtrl.newCategory()>New Category</button> &nbsp; <button class=\"btn btn-warning\" ng-click=editcategoryCtrl.saveCategoryOrder() ng-show=editcategoryCtrl.orderChanged>Save Order</button></small></h2><div ng-show=editcategoryCtrl.categoryMessage class=alert ng-class=editcategoryCtrl.categoryClass>{{ editcategoryCtrl.categoryMessage }}</div><ul class=available-categories><li class=parent-category ng-repeat=\"category in editcategoryCtrl.categories\">{{ category.name }}<ul data-as-sortable=editcategoryCtrl.dragControlListeners data-ng-model=category.children><li class=child-category ng-repeat=\"child in category.children\" ng-class=\"{\'alert-danger\': child.highlight}\" data-as-sortable-item><i class=\"fa fa-bars\" aria-hidden=true data-as-sortable-item-handle></i>&nbsp; <span ng-click=editcategoryCtrl.editCategory(child,category)>{{ child.name }}</span>&nbsp;<small ng-show=child.resources_count>({{ child.resources_count }})</small><span ng-show=child.highlight>>>Drag me to the desired position then click \'Save Order\'</span></li></ul></li></ul></div><div class=\"subcol col-md-6\"><div class=well ng-if=\"editcategoryCtrl.categoryToEdit === null\"><strong>Select a category to make changes</strong></div><div class=\"edit-category well\" ng-if=\"editcategoryCtrl.categoryToEdit !== null\"><strong>{{ editcategoryCtrl.categoryToEdit.name }}</strong><form class=category-form ng-submit=editcategoryCtrl.onEditSubmit() name=editcategoryCtrl.editcategoryForm novalidate><formly-form model=editcategoryCtrl.categoryToEdit fields=editcategoryCtrl.formFields form=editcategoryCtrl.editcategoryForm><div class=text-right><a class=\"btn btn-lg btn-default\" ng-click=editcategoryCtrl.removeCategory() ng-if=editcategoryCtrl.categoryToEdit.id>Remove</a> <button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editcategoryCtrl.editcategoryForm.$invalid>Save</button></div></formly-form></form></div><div class=\"edit-resource-order well\" ng-if=\"editcategoryCtrl.categoryToEdit !== null\"><strong>Resource Order</strong> <button class=\"btn btn-warning pull-right\" ng-click=editcategoryCtrl.saveResourceOrder() ng-show=editcategoryCtrl.orderResourcesChanged>Save Resource Order</button><ul data-as-sortable=editcategoryCtrl.dragResourceListeners data-ng-model=editcategoryCtrl.resourcesOfSelectedCategory><li class=resource-order ng-repeat=\"resource in editcategoryCtrl.resourcesOfSelectedCategory\" data-as-sortable-item><i class=\"fa fa-bars\" aria-hidden=true data-as-sortable-item-handle></i>&nbsp; <span>{{ resource.title }}</span></li></ul></div></div><script type=text/ng-template id=categoryModal.html><div class=\"modal-header\">\n      <h3 class=\"modal-title\" id=\"modal-title\">{{ categoryModalCtrl.alert.title }}</h3>\n    </div>\n    <div class=\"modal-body\" id=\"modal-body\">\n      {{ categoryModalCtrl.alert.body }}\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-primary\" type=\"button\" ng-show=\"categoryModalCtrl.alert.showOk\" ng-click=\"categoryModalCtrl.ok()\">OK</button>\n      <button class=\"btn btn-warning\" type=\"button\" ng-click=\"categoryModalCtrl.cancel()\">Cancel</button>\n    </div></script>");
$templateCache.put("app/pages/editresource/editresource.html","<div class=\"maincol col-md-12\"><h2><span ng-show=editresourceCtrl.isExisting>Edit \"{{ editresourceCtrl.resource.title }}\" </span><span ng-show=\"editresourceCtrl.isExisting !== true\">New Resource </span><span ng-show=editresourceCtrl.editresourceForm.$pristine>&nbsp;<a class=\"btn btn-info\" ui-sref=admin.resources>Resources</a> </span><span ng-show=\"editresourceCtrl.resource.id && editresourceCtrl.editresourceForm.$pristine\">&nbsp;<a class=\"btn btn-info\" ui-sref=\"resource({resourceSlug: editresourceCtrl.resource.slug})\">View</a> </span><span ng-show=\"editresourceCtrl.resource.id && editresourceCtrl.editresourceForm.$pristine\">&nbsp;<a class=\"btn btn-info\" ng-click=editresourceCtrl.deleteResource()>Delete Resource</a></span></h2><div ng-show=editresourceCtrl.resourceMessage class=alert ng-class=editresourceCtrl.resourceClass>{{ editresourceCtrl.resourceMessage }}</div><form class=resource-form ng-submit=editresourceCtrl.onEditSubmit() name=editresourceCtrl.editresourceForm novalidate><div class=col-md-8><formly-form model=editresourceCtrl.resource fields=editresourceCtrl.formFields form=editresourceCtrl.editresourceForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editresourceCtrl.editresourceForm.$invalid>Save</button></div></formly-form></div></form><div class=col-md-4><div ng-show=editresourceCtrl.isExisting><div class=feature-image><h3>Featured Image <a class=btn ng-click=editresourceCtrl.chooseUpdateImage() ng-if=\"editresourceCtrl.resource.feature.url !== null\">update</a> <a class=btn ng-click=editresourceCtrl.removeImage() ng-if=\"editresourceCtrl.resource.feature.url !== null\">remove</a> <a class=btn ng-click=editresourceCtrl.chooseNewImage() ng-if=\"editresourceCtrl.resource.feature.url === null\">new</a></h3><div ng-show=editresourceCtrl.resource.feature.url><img ng-src=\"{{ editresourceCtrl.resource.feature.url }}\"></div><p>{{ editresourceCtrl.resource.feature.url }}</p><div class=well ng-if=\"editresourceCtrl.imageToEdit !== null\"><form class=media-form ng-submit=editresourceCtrl.onImageSubmit() name=editresourceCtrl.editimageForm novalidate><formly-form model=editresourceCtrl.imageToEdit fields=editresourceCtrl.imageFormFields form=editresourceCtrl.editimageForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editresourceCtrl.editimageForm.$invalid>Upload</button></div></formly-form></form></div></div><hr><div class=media-content><h3>Media Content <a class=btn ng-click=editresourceCtrl.chooseNewMedia() ng-if=!editresourceCtrl.resource.media.url>new</a></h3><ul><li ng-repeat=\"media in editresourceCtrl.resource.media\"><a ng-click=\"editresourceCtrl.chooseUpdateMedia( media )\" title=Update><span>{{ media.title }} | {{ media.file_type }}</span>&nbsp; <i class=\"fa fa-pencil-square-o\"></i> </a>&nbsp; <a ng-click=\"editresourceCtrl.removeMedia( media )\" title=Delete><i class=\"fa fa-trash\"></i></a></li></ul><div class=well ng-if=\"editresourceCtrl.mediaToEdit !== null\"><button type=button class=close ng-click=editresourceCtrl.closeEditMedia() aria-label=Close><span aria-hidden=true>&times;</span></button><form class=media-form ng-submit=editresourceCtrl.onMediaSubmit() name=editresourceCtrl.editmediaForm novalidate><formly-form model=editresourceCtrl.mediaToEdit fields=editresourceCtrl.mediaFormFields form=editresourceCtrl.editmediaForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=editresourceCtrl.editmediaForm.$invalid>{{ editresourceCtrl.mediaToEdit.submit_text }}</button></div></formly-form></form></div></div></div><div class=well ng-hide=editresourceCtrl.isExisting><strong>Please first save this resource before attempting to add Media</strong></div><hr><h3>Categories</h3><ul class=available-categories><li class=parent-category ng-repeat=\"category in editresourceCtrl.resource.availableCategories\">{{ category.cat_name }}<ul><li class=child-category ng-repeat=\"child in category.children\"><div ng-click=editresourceCtrl.toggleCategory(child)><i class=\"selected-item fa fa-check-circle\" ng-show=child.selected aria-hidden=true></i>{{ child.cat_name }}</div></li></ul></li></ul></div></div>");
$templateCache.put("app/pages/home/home.html","<div class=\"subcol col-md-4 col-md-push-8\"><div class=row ng-show=home.user.loggedIn><div class=subcol-element ng-show=home.user.user.fullMember><a ui-sref=\"resource({resourceSlug: \'team-manual\'})\" class=\"btn btn-info btn-fullsize\"><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Download Team Manual</a></div><div class=subcol-element ng-hide=home.user.user.fullMember><a ui-sref=\"profile({formtype: \'upgrade\'})\" class=\"btn btn-info btn-fullsize\"><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Join as Full Member</a></div></div><div class=row ng-hide=home.user.loggedIn><div class=\"subcol-element text-center\"><div class=\"hidden-md hidden-lg\"><a ng-click=vm.openLogin() class=\"btn btn-inverse btn-fullsize\"><i class=\"fa fa-user\" aria-hidden=true></i> Login </a><br></div><a ng-click=home.openSignup() class=\"btn btn-info btn-fullsize\"><i class=\"fa fa-file-text-o\" aria-hidden=true></i> Join or Subscribe for Free</a></div></div><vg-category-grid category-slug=\"{{ home.categorySlug }}\" template-type=list>Loading...</vg-category-grid></div><div class=\"maincol col-md-8 col-md-pull-4\"><div class=welcome-text ng-bind-html=home.getWelcomeText()></div><br><h3>Featured Resource</h3><vg-resource-grid resources=home.resources></vg-resource-grid><div class=clearfix></div></div>");
$templateCache.put("app/pages/membership/membership.html","<div class=\"maincol col-xs-12\"><div class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title><span ng-if=\"membershipCtrl.formtype===\'signup\'\">Subscribe to</span><span ng-if=\"membershipCtrl.formtype!==\'signup\'\">Join</span> \'The Vine Project\'</h3></div><div class=panel-body><div ng-if=\"membershipCtrl.page == \'form\'\"><vg-form-signup form-type={{membershipCtrl.formtype}}></vg-form-signup></div><div ng-if=\"membershipCtrl.page == \'info\'\"><div class=text-center ng-hide=vm.user.loggedIn><a class=small ng-click=vm.openLogin()>Already a member? Login</a><br>&nbsp;<br></div><div class=membership-table><div class=\"row double-gap-top\"><div class=container-fluid><div class=col-md-6><div class=join-intro><p>Shaping your ministry culture around disciple-making won’t be easy. So we’ve created this website to support you.</p><p>Full membership (free) is for anyone committed to disciple-making culture change. Our extensive suite of resources include articles, podcasts, video, real world stories, and practical tools including templates, planning documents and more.</p><p>We’re also building a supportive community of like-minded people passionately committed to this ministry philosophy. We would love for you to join us!</p></div><br><div class=join-btn><a href=\"\" ui-sref=join.full class=\"btn btn-info btn-flat\" style=\"padding: 8px 14px\"><span>Join Free Now</span></a></div></div><div class=col-md-6><div class=\"heading clearfix inverse bg-col-primary\"><h4>Membership Benefits</h4></div><div class=\"price-box clearfix\"><ul class=\"no-list-style no-margin striped-ul\"><li><i class=\"fa fa-check\" aria-hidden=true></i> Full access to Disciple-Making Podcasts</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Subscription to Gotherefor.com articles</li><li><i class=\"fa fa-check\" aria-hidden=true></i> The Vine Project Team Manual</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Real World Stories</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Common Roadblocks</li><li><i class=\"fa fa-check\" aria-hidden=true></i> The Vine Project Phase Resources</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Ongoing Support from The Vine Project Team</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Access to thevineproject.com community</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Access to The Vine Project Facebook Group</li><li><i class=\"fa fa-check\" aria-hidden=true></i> Free to Join</li></ul></div><div class=join-btn><a href=\"\" ui-sref=join.full class=\"btn btn-block btn-info btn-flat\" style=\"padding: 8px 14px\"><span>Join Free Now</span></a></div></div><!--  <div class=\"heading clearfix inverse bg-midnight-blue\">\n                  <h4>Subscribe for updates</h4>\n                </div>\n                <div class=\"price-box clearfix\">\n                  <ul class=\"no-list-style no-margin striped-ul\">\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Receive regular updates about The Vine Project and what’s happening in teams around the world</li>\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Hear about the latest podcasts, videos and articles on disciple-making</li>\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Find out how you can pray for The Vine Project</li>\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Change your subscription details at any time or convert to a Full Membership</li>\n                    <li><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Free to Subscribe</li>\n                  </ul>\n                </div>\n                <div class=\"join-btn\"><a href=\"\" ui-sref=\"join.lite\" class=\"btn btn-block btn-inverse btn-flat\"><span>Subscribe Free Now</span></a></div>\n              </div> --></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/media/media.html","<div class=\"media-grid maincol col-md-8\"><h2>Media <a class=\"btn btn-lg btn-default\" ng-click=mediaCtrl.addNewImage()>Add New</a></h2><ul class=available-categories><li class=\"media-item col-md-3 col-xs-4\" ng-repeat=\"media in mediaCtrl.medias\"><a ng-click=mediaCtrl.editMedia(media)><div class=\"media-img img-crop-narrow\"><img ng-src=\"{{ media.url }}\" alt=\"{{ media.filename }}\"></div><div class=details><div class=caption><h5>{{ media.title }}</h5><h6>{{ media.filename }}</h6></div></div></a></li></ul><div class=clearfix></div><ul uib-pagination items-per-page=mediaCtrl.medias.pagination.per_page total-items=mediaCtrl.medias.pagination.total ng-model=mediaCtrl.pagination ng-change=mediaCtrl.pageChanged()></ul></div><div class=\"subcol col-md-4\"><div class=well ng-if=\"mediaCtrl.mediaToEdit === null\"><strong>Select a media Item to make changes</strong></div><div class=\"edit-media well\" ng-if=\"mediaCtrl.mediaToEdit !== null\"><form class=media-form ng-submit=mediaCtrl.onEditSubmit() name=mediaCtrl.editmediaForm novalidate><formly-form model=mediaCtrl.mediaToEdit fields=mediaCtrl.formFields form=mediaCtrl.editmediaForm><div class=text-right><a class=\"btn btn-lg btn-default\" ng-click=mediaCtrl.removeImage() ng-if=mediaCtrl.mediaToEdit.url>Remove</a> <button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=mediaCtrl.editmediaForm.$invalid>Save</button></div></formly-form></form><hr><p>url: {{ mediaCtrl.mediaToEdit.url }}</p><img ng-src=\"{{ mediaCtrl.mediaToEdit.url }}\" alt=\"{{ mediaCtrl.mediaToEdit.filename }}\"></div></div>");
$templateCache.put("app/pages/password/change.html","<!-- Password Reset Form --><div class=\"well col-md-6 col-md-offset-3\"><h1>Password Reset</h1><div ng-show=passCtrl.messageMessage class=alert ng-class=passCtrl.messageClass>{{ passCtrl.messageMessage }}</div><form ng-submit=passCtrl.onChangeSubmit() name=passCtrl.passwordChangeForm novalidate><formly-form model=passCtrl.model fields=passCtrl.passwordChangeFields form=passCtrl.passwordChangeForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=passCtrl.passwordChangeForm.$invalid>Reset Password</button> <span us-spinner=\"{radius:5, length:10, width:5, left:\'70%\'}\" spinner-key=submit-spinner></span></div></formly-form></form></div>");
$templateCache.put("app/pages/password/reset.html","<!-- Password Reset Form --><div class=\"well col-md-6 col-md-offset-3\"><h1>Forgot Password?</h1><div ng-show=passCtrl.messageMessage class=alert ng-class=passCtrl.messageClass>{{ passCtrl.messageMessage }}</div><form ng-submit=passCtrl.onResetSubmit() name=passCtrl.passwordResetForm novalidate><formly-form model=passCtrl.model fields=passCtrl.passwordResetFields form=passCtrl.passwordResetForm><div class=text-right><button type=submit class=\"btn btn-lg btn-primary\" ng-disabled=passCtrl.passwordResetForm.$invalid>Request Password Reset Email</button> <span us-spinner=\"{radius:5, length:10, width:5, left:\'70%\'}\" spinner-key=submit-spinner></span></div></formly-form></form></div>");
$templateCache.put("app/pages/profile/profile.html","<div class=\"maincol col-xs-12 col-md-8 col-md-offset-2\"><div ng-show=vm.user.loggedIn class=\"panel panel-default\"><div class=panel-heading><h3 class=panel-title>{{ vm.user.user.firstname }}\'s Profile</h3></div><div class=panel-body><div ng-show=\"profileCtrl.formtype==\'upgrade\'\" class=\"alert alert-info\"><h3>To Upgrade your Membership</h3><p>To enable access to the Team Manual and more resources and allow our team to work alongside you to help you succeed, we\'ll need a little more information.</p><p><strong>Upgrading your membership will not cost you anything</strong></p><p>Please check the box \'Team Membership: I plan to start The Vine Project with my Church/Organisation\' and fill in the additional fields</p></div><vg-form-signup form-type={{profileCtrl.formtype}}></vg-form-signup></div></div><div class=well ng-hide=vm.user.loggedIn><strong>Please log in to access this page</strong></div></div>");
$templateCache.put("app/pages/resource/resource.html","<div class=\"maincol col-xs-12 col-lg-8\"><article><div class=article-meta><h2>{{ resource.title }} <a ng-show=resource.canEdit class=\"btn btn-primary\" ui-sref=\"admin.editresource({resourceSlug: resource.slug})\">Edit</a></h2><span>{{ resource.author.name }} | {{ resource.published }}</span><div class=categories><a ng-repeat=\"category in resource.categories\" ui-sref=\"category({ categorySlug: category.slug })\" class=\"label label-default\">{{ category.name }}</a><div class=clearfix></div></div></div><div class=article-body><div class=mediaplayer ng-if=resource.mediaSources.mediaPlayer.enabled><div class=\"responsive-embed-container video-container\" ng-if=\"resource.mediaSources.mediaPlayer.player === \'vimeo\'\"><iframe ng-src=\"{{ resource.mediaSources.mediaPlayer.url }}\" frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div><div class=\"responsive-embed-container audio-container\" ng-if=\"resource.mediaSources.mediaPlayer.player === \'audio\'\"><h4>{{ resource.mediaSources.mediaPlayer.title }}</h4><uib-progressbar class=\"progress-striped active\" value=\"\" type=info ng-show=!resource.audio.duration>loading...</uib-progressbar><div class=\"row audio-controls\" ng-show=resource.audio.duration><div class=\"player-progress col-md-8 col-xs-12\"><div class=input-group><span ng-click=\"resource.audio.paused ? resource.audio.play() : resource.audio.pause()\" class=\"input-group-addon glyphicon\" ng-class=\"resource.audio.paused ? \'glyphicon-play\' : \'glyphicon-pause\'\" aria-hidden=true></span> <input class=form-control type=range min=0 max=1 step=0.01 ng-model=resource.audio.progress></div></div><div class=\"player-volume col-md-4 col-xs-12\"><div class=input-group><span ng-click=\"resource.audio.muting = !resource.audio.muting\" class=\"input-group-addon glyphicon\" ng-class=\"resource.audio.muting ? \'glyphicon-volume-off\' : resource.audio.volume > 0.5 ? \'glyphicon-volume-up\' : \'glyphicon-volume-down\'\" aria-hidden=true></span> <input class=form-control type=range min=0 max=1 step=0.01 ng-model=resource.audio.volume></div></div></div><div>Current Time: {{resource.audio.currentTime | trackTime}} / {{resource.audio.duration | trackTime}}</div></div></div><div class=\"article-img img-crop-narrow\" ng-if=\"resource.hide_feature!=true && resource.mediaSources.mediaPlayer.enabled!=true\"><img ng-src=\"{{ resource.feature }}\"></div><div class=downloads ng-if=\"resource.mediaSources.downloads.length > 0\"><h2><ng-pluralize count=resource.mediaSources.downloads.length when=\"{\n              \'0\': \'\',\n              \'one\': \'Download\',\n              \'other\': \'Downloads\'\n            }\"></ng-pluralize>&nbsp; <i class=\"fa fa-cloud-download\"></i></h2><hr><ul><li ng-repeat=\"download in resource.mediaSources.downloads\"><a ng-href={{download.url}} target=_blank>{{ download.title }}&nbsp;<i class=fa ng-class=download.icon></i></a></li></ul></div><div ta-bind ng-model=resource.content></div><br><hr>&copy; Vinegrowers {{ resource.currentYear }}</div></article><div class=\"author-bio media\"><div class=media-left><a href=#><img class=\"media-object img-circle\" ng-src=\"{{ resource.author.thumbnail }}\" alt=\"{{ resource.author.name }}\"></a></div><div class=media-body><h4 class=media-heading>About {{ resource.author.name }}</h4>{{ resource.author.bio }}</div></div></div><div class=\"subcol col-xs-12 col-lg-4\"><!-- <vg-sidebar></vg-sidebar> --><vg-comments comments=resource.comments resource=resource></vg-comments></div>");
$templateCache.put("app/pages/search/search.html","<div class=\"maincol col-md-8\"><h3>Search Results</h3><div class=page-intro ng-if=\"searchCtrl.results.length === 0 && searchCtrl.searching !== true\"><h5>No items found for your search</h5></div><div class=page-intro ng-show=searchCtrl.searching><h5>Searching...</h5></div><vg-resource-grid resources=searchCtrl.results></vg-resource-grid><div class=clearfix></div></div>");}]);